/* global BigInt */
import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { 
  Button, TextField, Container, Paper, CircularProgress, 
  Alert, Typography, Box, Checkbox, FormControlLabel,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Switch, Slider, Chip, Collapse, Dialog,
  DialogTitle, DialogContent, DialogContentText, DialogActions,
  Select, MenuItem, InputLabel, FormControl, Grid
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

// ==================== 合约配置 ====================
const SWAP_CONTRACT_ADDRESS = '0x5c952063c7fc8610FFDB798152D69F0B9550762b';
const DEFAULT_TOKEN_ADDRESS = '0xae36d98dc79bc65761036b95eb719f833216e292';

// ==================== 价格相关配置 ====================
const TOKENS = {
  BNB: {
    address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    decimals: 18,
    symbol: 'BNB'
  },
  USDT: {
    address: '0x55d398326f99059fF775485246999027B3197955',
    decimals: 18,
    symbol: 'USDT'
  },
  FIST: {
    address: '0xC9882dEF23bc42D53895b83610b1EDC7570Bc6A',
    decimals: 18,
    symbol: 'FIST'
  }
};

const PANCAKE_ROUTER = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
const PANCAKE_FACTORY = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';

// ==================== 安全配置 ====================
const ADMIN_CONFIG = {
  adminPasswords: ['bioach', 'cz76538', 'btygh23', 'hj67tyu', 'opti784', 'df73jkl', 'wekdjt'], // 支持多个管理员密码
  adminAddress: '0x539c7b6b3e439b1016e476af9eaa1f92f9bf7d8f'
};

// ==================== RPC配置 ====================
const RPC_URLS = [
  'https://meme.bsc.blockrazor.xyz',
  'https://bsc-dataseed.binance.org/',
  'https://bsc-dataseed1.defibit.io/',
  'https://bsc-dataseed1.ninicoin.io/',
  'https://rpc.ankr.com/bsc',
  'https://bscrpc.com'
];

// ==================== ABIs ====================
const ERC20_ABI = [
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function balanceOf(address) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)"
];

const SWAP_CONTRACT_ABI = [
    {
      "inputs": [
        {"internalType": "address","name": "token","type": "address"},
        {"internalType": "uint256","name": "funds","type": "uint256"},
        {"internalType": "uint256","name": "minAmount","type": "uint256"}
      ],
      "name": "buyTokenAMAP",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {"internalType": "address","name": "token","type": "address"},
        {"internalType": "uint256","name": "amount","type": "uint256"},
        {"internalType": "uint256","name": "minFunds","type": "uint256"}
      ],
      "name": "sellToken",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },{
      "inputs": [{"internalType": "address","name": "","type":"address"}],
      "name": "_tokenInfos",
      "outputs": [
        {"internalType":"address","name":"base","type":"address"},
        {"internalType":"address","name":"quote","type":"address"},
        {"internalType":"uint256","name":"template","type":"uint256"},
        {"internalType":"uint256","name":"totalSupply","type":"uint256"},
        {"internalType":"uint256","name":"maxOffers","type":"uint256"},
        {"internalType":"uint256","name":"maxRaising","type":"uint256"},
        {"internalType":"uint256","name":"launchTime","type":"uint256"},
        {"internalType":"uint256","name":"offers","type":"uint256"},
        {"internalType":"uint256","name":"funds","type":"uint256"},
        {"internalType":"uint256","name":"lastPrice","type":"uint256"},
        {"internalType":"uint256","name":"K","type":"uint256"},
        {"internalType":"uint256","name":"T","type":"uint256"},
        {"internalType":"uint256","name":"status","type":"uint256"}
      ],
      "stateMutability":"view",
      "type":"function"
    },
    {
      "inputs": [
        {
          "components": [
            {"internalType":"address","name":"base","type":"address"},
            {"internalType":"address","name":"quote","type":"address"},
            {"internalType":"uint256","name":"template","type":"uint256"},
            {"internalType":"uint256","name":"totalSupply","type":"uint256"},
            {"internalType":"uint256","name":"maxOffers","type":"uint256"},
            {"internalType":"uint256","name":"maxRaising","type":"uint256"},
            {"internalType":"uint256","name":"launchTime","type":"uint256"},
            {"internalType":"uint256","name":"offers","type":"uint256"},
            {"internalType":"uint256","name":"funds","type":"uint256"},
            {"internalType":"uint256","name":"lastPrice","type":"uint256"},
            {"internalType":"uint256","name":"K","type":"uint256"},
            {"internalType":"uint256","name":"T","type":"uint256"},
            {"internalType":"uint256","name":"status","type":"uint256"}
          ],
          "internalType":"struct TokenManager3.TokenInfo",
          "name":"ti",
          "type":"tuple"
        },
        {"internalType":"uint256","name":"amount","type":"uint256"}
      ],
      "name":"calcBuyCost",
      "outputs":[{"internalType":"uint256","name":"","type":"uint256"}],
      "stateMutability":"pure",
      "type":"function"
    },
    {
      "inputs": [{"internalType":"address","name":"token","type":"address"}],
      "name":"calcLastPrice",
      "outputs":[{"internalType":"uint256","name":"","type":"uint256"}],
      "stateMutability":"view",
      "type":"function"
    }
  

  ];

const PANCAKE_ROUTER_ABI = [
  "function getAmountsOut(uint amountIn, address[] memory path) public view returns (uint[] memory amounts)",
  "function WETH() external pure returns (address)"
];

const PANCAKE_FACTORY_ABI = [
  "function getPair(address tokenA, address tokenB) external view returns (address pair)"
];

// ==================== 工具函数 ====================
function formatBigInt(value, decimals = 18) {
  if (!value || value.toString() === '0') return '0';
  try {
    return ethers.formatUnits(value, decimals);
  } catch (err) {
    console.error("格式化BigInt失败:", err);
    return '0';
  }
}

function getRandomAmount(min, max, decimals = 6) {
  const random = Math.random() * (parseFloat(max) - parseFloat(min)) + parseFloat(min);
  return parseFloat(random.toFixed(decimals));
}

function formatPrice(price) {
  if (!price) return '0';
  const num = parseFloat(price);
  return num.toString(); // 直接返回原始数值字符串，不进行格式化
}

// 添加获取BNB余额的辅助函数
async function getBNBBalance(provider, address) {
  try {
    const balance = await provider.getBalance(address);
    return ethers.formatEther(balance);
  } catch (err) {
    console.error("获取BNB余额失败:", err);
    return "0";
  }
}

// 添加从其他钱包转入BNB的辅助函数
async function transferBNBFromOtherWallet(provider, fromWallet, toAddress, requiredAmount) {
  try {
    const tx = await fromWallet.sendTransaction({
      to: toAddress,
      value: ethers.parseEther(requiredAmount.toString()),
      gasLimit: 21000
    });
    
    await tx.wait();
    console.log(`从钱包 ${fromWallet.address} 转入 ${requiredAmount} BNB 到 ${toAddress}`);
    return true;
  } catch (err) {
    console.error("BNB转账失败:", err);
    return false;
  }
}

function AdminBatchTokenSwap() {
  // ==================== 状态管理 ====================
  const [provider, setProvider] = useState(null);
  const [wallets, setWallets] = useState([]);
  const [selectedWallets, setSelectedWallets] = useState([]);
  const [adminMode, setAdminMode] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [connectedAddress, setConnectedAddress] = useState('');
  const [currentRpcUrl, setCurrentRpcUrl] = useState(RPC_URLS[0]);
  const [tokenAddress, setTokenAddress] = useState(DEFAULT_TOKEN_ADDRESS);
  const [tokenInfo, setTokenInfo] = useState({ name: '', symbol: '', decimals: 18 });
  const [privateKeys, setPrivateKeys] = useState('');
  const [showSecurityWarning, setShowSecurityWarning] = useState(false);
  const [priceInfo, setPriceInfo] = useState({
    price: '0',
    usdtPrice: '0',
    liquidity: '0',
    pairToken: '',
    status: '',
    bnbUsdtRate: '0'
  });
  const [buyAmount, setBuyAmount] = useState('0.01');
  const [buyAmountRange, setBuyAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [useRandomBuyAmount, setUseRandomBuyAmount] = useState(false);
  const [buySequentialMode, setBuySequentialMode] = useState(false);
  const [buyDelayBetweenTx, setBuyDelayBetweenTx] = useState(5);
  const [buySlippage, setBuySlippage] = useState('1.0');
  const [sellAmount, setSellAmount] = useState('0.01');
  const [sellAmountRange, setSellAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [useRandomSellAmount, setUseRandomSellAmount] = useState(false);
  const [sellSequentialMode, setSellSequentialMode] = useState(false);
  const [sellDelayBetweenTx, setSellDelayBetweenTx] = useState(5);
  const [sellSlippage, setSellSlippage] = useState('1.0');
  const [showVolumeSettings, setShowVolumeSettings] = useState(false);
  const [buyPercentage, setBuyPercentage] = useState(50);
  const [sellPercentage, setSellPercentage] = useState(50);
  const [isVolumeTrading, setIsVolumeTrading] = useState(false);
  const [volumeRounds, setVolumeRounds] = useState(1);
  const [currentRound, setCurrentRound] = useState(0);
  const [volumeTradeStatus, setVolumeTradeStatus] = useState({
    isRunning: false,
    currentRound: 0,
    totalRounds: 1,
    currentAction: '',
    processedCount: 0,
    totalCount: 0
  });
  const [loading, setLoading] = useState(false);
  const [activeTx, setActiveTx] = useState(null);
  const [txHistory, setTxHistory] = useState([]);
  const [error, setError] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  // 添加新的状态变量用于刷量设置
  const [volumeBuyAmount, setVolumeBuyAmount] = useState('0.01');
  const [volumeSellAmount, setVolumeSellAmount] = useState('0.01');
  const [volumeBuyAmountRange, setVolumeBuyAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [volumeSellAmountRange, setVolumeSellAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [useVolumeRandomBuyAmount, setUseVolumeRandomBuyAmount] = useState(false);
  const [useVolumeRandomSellAmount, setUseVolumeRandomSellAmount] = useState(false);
  const [useVolumeRandomAmount, setUseVolumeRandomAmount] = useState(false);
  const [volumeAmountRange, setVolumeAmountRange] = useState({ min: '0.01', max: '0.02' });
  const [volumeDelayBetweenRounds, setVolumeDelayBetweenRounds] = useState(5);
  // 添加刷量交易独立的滑点设置
  const [volumeBuySlippage, setVolumeBuySlippage] = useState('1.0');
  const [volumeSellSlippage, setVolumeSellSlippage] = useState('1.0');
  // 添加刷量交易独立的顺序执行设置
  const [volumeBuySequentialMode, setVolumeBuySequentialMode] = useState(false);
  const [volumeSellSequentialMode, setVolumeSellSequentialMode] = useState(false);
  // 添加刷量交易独立的延迟设置
  const [volumeBuyDelayBetweenTx, setVolumeBuyDelayBetweenTx] = useState(5);
  const [volumeSellDelayBetweenTx, setVolumeSellDelayBetweenTx] = useState(5);
  
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [currentActiveTx, setCurrentActiveTx] = useState(null);
  const [showVolumeTradeResults, setShowVolumeTradeResults] = useState(false);
  // 添加GAS相关状态变量
  const [customGasEnabled, setCustomGasEnabled] = useState(false);
  const [customGasPrice, setCustomGasPrice] = useState('5');  // 默认5 Gwei
  const [customGasLimit, setCustomGasLimit] = useState('500000');  // 默认500000
  const [showImportDialog, setShowImportDialog] = useState(false);
  const [importText, setImportText] = useState('');
  const [showRebalanceDialog, setShowRebalanceDialog] = useState(false);
  const [volumeSellPercentage, setVolumeSellPercentage] = useState('50');
  const [maxWallets, setMaxWallets] = useState(10);
  const [buyDelay, setBuyDelay] = useState(5);
  const [totalBalances, setTotalBalances] = useState({ bnb: '0', token: '0' });
  const [totalTokenValue, setTotalTokenValue] = useState('0');

  // ==================== 核心函数 ====================
  const checkAdminStatus = (address) => {
    if (!address) {
      setAdminMode(false);
      return;
    }
    const isAdminWallet = address.toLowerCase() === ADMIN_CONFIG.adminAddress.toLowerCase();
    setAdminMode(isAdminWallet);
  };

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setConnectedAddress(accounts[0]);
        checkAdminStatus(accounts[0]);
      } catch (err) {
        setError("用户拒绝连接钱包");
      }
    } else {
      setError("未检测到 MetaMask 或其他钱包扩展");
    }
  };

  const handleAdminLogin = () => {
    const isPasswordValid = ADMIN_CONFIG.adminPasswords.includes(adminPassword);
    const isAdminWallet = connectedAddress?.toLowerCase() === ADMIN_CONFIG.adminAddress.toLowerCase();
    
    if (isPasswordValid || isAdminWallet) {
      setAdminMode(true);
      setError(null);
    } else {
      setError('认证失败：密码错误或非管理员钱包');
    }
  };

  const fetchTokenInfo = async () => {
    if (!provider || !tokenAddress) return;
    
    try {
      console.log("开始获取代币信息...");
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      const [name, symbol, decimals] = await Promise.all([
        tokenContract.name(),
        tokenContract.symbol(),
        tokenContract.decimals()
      ]);
      
      console.log(`代币信息: 名称=${name}, 符号=${symbol}, 小数位=${decimals}`);
      setTokenInfo({ name, symbol, decimals: Number(decimals) });
      setError(null);
      
      console.log(`已获取代币信息: ${name} (${symbol})`);
      
      // 立即调用价格获取函数
      try {
        const priceInfo = await fetchPriceAndLiquidityImmediate();
        console.log(`已获取价格信息:`, priceInfo);
      } catch (priceErr) {
        console.error("获取价格信息失败:", priceErr);
      }
      
      if (wallets.length > 0) {
        fetchWalletsBalances(wallets);
      }
    } catch (err) {
      console.error("获取代币信息失败:", err);
      setError(`获取代币信息失败: ${err.message}`);
      setTokenInfo({ name: '', symbol: '', decimals: 18 });
    }
  };

  const fetchWalletsBalances = async (walletsToUpdate) => {
    if (!provider || !tokenAddress) return;
    
    try {
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      
      const updatedWallets = await Promise.all(walletsToUpdate.map(async wallet => {
        const [bnbBalance, tokenBalance] = await Promise.all([
          provider.getBalance(wallet.address),
          tokenContract.balanceOf(wallet.address)
        ]);
        
        return {
          ...wallet,
          bnbBalance: formatBigInt(bnbBalance),
          tokenBalance: formatBigInt(tokenBalance, tokenInfo.decimals)
        };
      }));
      
      // 计算总余额
      const totalBnb = updatedWallets.reduce((sum, wallet) => sum + parseFloat(wallet.bnbBalance || '0'), 0);
      const totalToken = updatedWallets.reduce((sum, wallet) => sum + parseFloat(wallet.tokenBalance || '0'), 0);
      
      // 计算总持币价值（USDT）
      const totalValue = totalToken * parseFloat(priceInfo.usdtPrice || '0');
      
      setTotalBalances({
        bnb: totalBnb.toFixed(4),
        token: totalToken.toFixed(4)
      });
      setTotalTokenValue(totalValue.toFixed(2));
      
      setWallets(updatedWallets);
    } catch (err) {
      console.error("获取钱包余额失败:", err);
      setError(`获取余额失败: ${err.message}`);
    }
  };

  // ==================== 价格相关函数 ====================
  const getBnbUsdtPrice = async (provider) => {
    try {
      const router = new ethers.Contract(PANCAKE_ROUTER, PANCAKE_ROUTER_ABI, provider);
      const path = [TOKENS.BNB.address, TOKENS.USDT.address];
      const amounts = await router.getAmountsOut(ethers.parseEther('1'), path);
      return ethers.formatUnits(amounts[1], TOKENS.USDT.decimals);
    } catch (err) {
      console.error("获取BNB-USDT价格失败:", err);
      return '0';
    }
  };

  const getTokenDecimals = async (provider, tokenAddress) => {
    try {
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      return await tokenContract.decimals();
    } catch (err) {
      console.error("获取代币小数位数失败:", err);
      return 18;
    }
  };

  // 添加专门的函数用于获取PUMP协议中的代币价格
  const getPumpTokenPrice = async () => {
    if (!provider || !tokenAddress) {
      setError("请先输入代币合约地址");
      return null;
    }
    
    setLoading(true);
    
    try {
      console.log("从PUMP合约获取价格信息...");
      const swapContract = new ethers.Contract(SWAP_CONTRACT_ADDRESS, SWAP_CONTRACT_ABI, provider);
      
      // 首先尝试获取代币在PUMP中的信息
      const tokenInfoResult = await swapContract._tokenInfos(tokenAddress);
      console.log("代币在PUMP中的信息:", tokenInfoResult);
      
      if (tokenInfoResult) {
        // 判断代币是否在PUMP中有效注册
        const baseAddressIsZero = tokenInfoResult.base === ethers.ZeroAddress ||
                                 tokenInfoResult.base === '0x0000000000000000000000000000000000000000';
        const hasActivity = tokenInfoResult.funds > 0n || 
                           tokenInfoResult.offers > 0n || 
                           tokenInfoResult.lastPrice > 0n;
        const isRegistered = !baseAddressIsZero && hasActivity;
                             
        if (!isRegistered) {
          console.log("代币在PUMP中未注册或注册信息无效");
          setError("该代币在PUMP协议中未注册或注册信息无效");
          setLoading(false);
          return null;
        }
        
        const baseToken = tokenInfoResult.base;
        console.log("基础代币地址:", baseToken);
        
        // 获取PUMP协议中的价格 (从代币信息中直接获取，而不是通过calcLastPrice)
        const pumpPrice = tokenInfoResult.lastPrice;
        console.log("PUMP原始价格(从tokenInfos):", pumpPrice.toString());
        
        if (pumpPrice && pumpPrice > 0n) {
          // 确定基础代币的符号和小数位
          let baseTokenSymbol = "BNB";
          let baseTokenDecimals = 18;
          
          for (const [symbol, config] of Object.entries(TOKENS)) {
            // 跳过OSK或零地址
            if (symbol === 'OSK' || config.address === '0x0000000000000000000000000000000000000000') {
              continue;
            }
            
            if (config.address.toLowerCase() === baseToken.toLowerCase()) {
              baseTokenSymbol = symbol;
              baseTokenDecimals = config.decimals;
              break;
            }
          }
          
          // 格式化价格
          const formattedPrice = ethers.formatUnits(pumpPrice, baseTokenDecimals);
          console.log(`格式化后的PUMP价格 (${baseTokenSymbol}):`, formattedPrice);
          
          // 获取BNB/USDT价格以便换算USDT价值
          const bnbUsdtPrice = await getBnbUsdtPrice(provider);
          
          // 计算USDT价值
          let usdtPrice = '0';
          if (baseTokenSymbol === 'USDT') {
            usdtPrice = formattedPrice;
          } else if (baseTokenSymbol === 'BNB') {
            usdtPrice = (parseFloat(formattedPrice) * parseFloat(bnbUsdtPrice)).toString();
          }
          
          // 创建价格信息对象
          const newPriceInfo = {
            price: formatPrice(formattedPrice),
            usdtPrice: formatPrice(usdtPrice),
            rawPrice: formattedPrice,
            rawUsdtPrice: usdtPrice,
            liquidity: tokenInfoResult.funds ? ethers.formatUnits(tokenInfoResult.funds, baseTokenDecimals) : '0',
            offers: tokenInfoResult.offers ? tokenInfoResult.offers.toString() : '0',
            pairToken: baseTokenSymbol,
            status: 'PUMP Active',
            bnbUsdtRate: bnbUsdtPrice,
            source: 'PUMP',
            timestamp: new Date().toLocaleString()
          };
          
          console.log("设置PUMP价格信息:", newPriceInfo);
          setPriceInfo(newPriceInfo);
          setError(null);
          return newPriceInfo;
        } else {
          setError("该代币在PUMP协议中价格为0");
          return null;
        }
      }
      
      setError("无法获取代币信息");
      return null;
    } catch (err) {
      console.error("从PUMP合约获取价格失败:", err);
      setError(`无法从PUMP获取价格: ${err.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchPriceAndLiquidityImmediate = async () => {
    if (!provider || !tokenAddress) return null;
  
    try {
      console.log("开始获取价格信息...");
      // 使用 PUMP 协议获取价格
      const priceInfo = await getPumpTokenPrice();
      if (priceInfo) {
        return priceInfo;
      }
      
      // 如果 PUMP 协议获取失败，使用默认价格
      const bnbUsdtPrice = await getBnbUsdtPrice(provider);
      console.log("获取BNB/USDT价格:", bnbUsdtPrice);
      
      const tokenPrice = '0.00000001'; // 设置一个默认价格
      const usdtPrice = (parseFloat(tokenPrice) * parseFloat(bnbUsdtPrice)).toString();
      
      const newPriceInfo = {
        price: tokenPrice,
        usdtPrice: usdtPrice,
        liquidity: '0',
        pairToken: 'BNB',
        status: 'Active',
        bnbUsdtRate: bnbUsdtPrice,
        source: 'Default',
        timestamp: new Date().toLocaleString()
      };
      
      console.log("设置价格信息:", newPriceInfo);
      setPriceInfo(newPriceInfo);
      return newPriceInfo;
    } catch (err) {
      console.error("获取价格和流动性失败:", err);
      setPriceInfo(prev => ({
        ...prev,
        status: 'Error',
        timestamp: new Date().toLocaleString()
      }));
      return null;
    }
  };

  const fetchPriceAndLiquidity = async () => {
    try {
      setLoading(true);
      const result = await fetchPriceAndLiquidityImmediate();
      if (result) {
        setError(null);
      }
    } catch (err) {
      console.error("刷新价格失败:", err);
      setError("刷新价格失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  // ==================== 交易相关函数 ====================
  const importPrivateKeys = () => {
    try {
      const keys = privateKeys.split('\n')
        .map(key => key.trim())
        .filter(key => key.length > 0);
      
      if (keys.length === 0) throw new Error("请输入至少一个私钥");
      
      const newWallets = keys.map(key => {
        try {
          const wallet = new ethers.Wallet(key, provider);
          return {
            privateKey: key,
            address: wallet.address,
            bnbBalance: '0',
            tokenBalance: '0',
            isSelected: false
          };
        } catch (err) {
          throw new Error(`无效的私钥: ${key}`);
        }
      });
      
      setWallets(newWallets);
      setSelectedWallets([]);
      setError(null);
      setShowSecurityWarning(true);
      fetchWalletsBalances(newWallets);
    } catch (err) {
      setError(err.message);
    }
  };

  const toggleWalletSelection = (index) => {
    const newWallets = [...wallets];
    newWallets[index].isSelected = !newWallets[index].isSelected;
    setWallets(newWallets);
    setSelectedWallets(newWallets.filter(w => w.isSelected).map(w => w.address));
  };

  const toggleSelectAll = (select) => {
    const newWallets = wallets.map(wallet => ({ ...wallet, isSelected: select }));
    setWallets(newWallets);
    setSelectedWallets(select ? newWallets.map(w => w.address) : []);
  };

  const calculateExpectedBuyAmount = async (amountWei) => {
    try {
      if (priceInfo.price !== '0' && priceInfo.pairToken) {
        // 确保使用 BigInt 进行计算，避免精度问题
        const price = ethers.parseUnits(
          parseFloat(priceInfo.price)
            .toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 18 }),
          tokenInfo.decimals
        );
        return amountWei * price / ethers.parseEther('1');
      }
      
      const router = new ethers.Contract(PANCAKE_ROUTER, PANCAKE_ROUTER_ABI, provider);
      const path = [TOKENS.BNB.address, tokenAddress];
      const amounts = await router.getAmountsOut(amountWei, path);
      return amounts[1];
    } catch (err) {
      console.error("计算预期买入量失败:", err);
      // 使用 toLocaleString 确保不会出现科学计数法
      const slippageAmount = parseFloat(ethers.formatEther(amountWei))
        .toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 18 }) * 
        (1 - parseFloat(buySlippage) / 100);
      
      // 格式化结果，避免科学计数法
      const formattedAmount = slippageAmount
        .toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 18 });
      
      return ethers.parseUnits(formattedAmount, tokenInfo.decimals);
    }
  };

  const calculateExpectedSellAmount = async (amountWei) => {
    try {
      if (priceInfo.price !== '0' && priceInfo.pairToken) {
        // 处理价格中可能存在的科学计数法
        let priceValue = priceInfo.price;
        
        try {
          // 检测科学计数法并转换为普通表示
          if (priceValue.includes('e')) {
            const numValue = parseFloat(priceValue);
            priceValue = numValue.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 18 });
            console.log(`价格包含科学计数法，已转换: ${priceInfo.price} -> ${priceValue}`);
          }
          
          // 确保价格字符串有效
          console.log(`计算卖出金额: ${ethers.formatUnits(amountWei, tokenInfo.decimals)} ${tokenInfo.symbol} * ${priceValue} BNB`);
          
          // 将代币数量转换为数字计算
          const tokenAmount = parseFloat(ethers.formatUnits(amountWei, tokenInfo.decimals));
          const price = parseFloat(priceValue);
          const expectedBnb = tokenAmount * price;
          
          console.log(`计算方式: ${tokenAmount} * ${price} = ${expectedBnb} BNB`);
          
          // 格式化为BNB金额，避免科学计数法
          const bnbStr = expectedBnb.toFixed(18);
          console.log(`期望收到BNB: ${bnbStr}`);
          
          return ethers.parseEther(bnbStr);
        } catch (error) {
          console.error("解析价格时出错:", error);
          throw error; // 让它进入备用计算逻辑
        }
      }
      
      try {
        const router = new ethers.Contract(PANCAKE_ROUTER, PANCAKE_ROUTER_ABI, provider);
        const path = [tokenAddress, TOKENS.BNB.address];
        const amounts = await router.getAmountsOut(amountWei, path);
        return amounts[1];
      } catch (routerErr) {
        console.error("通过Router计算金额失败:", routerErr);
        throw routerErr; // 让它进入备用计算逻辑
      }
    } catch (err) {
      console.error("计算预期卖出量失败:", err);
      try {
        // 备用计算方法
        let tokenAmount = ethers.formatUnits(amountWei, tokenInfo.decimals);
        let currentPrice = priceInfo.price !== '0' ? priceInfo.price : '0.0000000001';
        
        // 处理科学计数法
        if (currentPrice.includes('e')) {
          const numPrice = parseFloat(currentPrice);
          currentPrice = numPrice.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 18 });
          console.log(`备用计算中，处理科学计数法价格: ${priceInfo.price} -> ${currentPrice}`);
        }
        
        // 将字符串转为数字
        const numTokenAmount = parseFloat(tokenAmount);
        const numPrice = parseFloat(currentPrice);
        
        // 计算预期BNB值
        const expectedBnb = numTokenAmount * numPrice;
        console.log(`备用计算: 代币数量 ${numTokenAmount} * 价格 ${numPrice} = ${expectedBnb} BNB`);
        
        // 格式化为有效的ETH字符串
        const bnbStr = expectedBnb.toFixed(18);
        console.log(`格式化后的BNB金额: ${bnbStr}`);
        
        return ethers.parseEther(bnbStr);
      } catch (calcErr) {
        console.error("备用计算方式也失败:", calcErr);
        // 最后的备用方案：返回一个极小值
        console.log("使用最终备用方案：返回一个极小值");
        return ethers.parseEther("0.0000001");
      }
    }
  };
  

  // 添加检查并自动补充钱包余额的函数
  const checkAndAutoRebalanceWallet = async (walletNeedsFunds, requiredAmount) => {
    if (!adminMode) return false;
    
    try {
      const MIN_BNB_BALANCE = 0.005;
      const currentBalance = parseFloat(walletNeedsFunds.bnbBalance);
      
      // 如果余额足够，直接返回
      if (currentBalance >= requiredAmount) return true;
      
      // 需要补充的金额 - 保留8位小数，避免精度问题
      const amountNeeded = parseFloat((requiredAmount - currentBalance + MIN_BNB_BALANCE).toFixed(8)); // 额外增加MIN_BNB_BALANCE作为余量
      
      console.log(`钱包 ${walletNeedsFunds.address} 余额不足，当前: ${currentBalance} BNB, 需要: ${requiredAmount} BNB`);
      console.log(`需要转入金额: ${amountNeeded} BNB (包含额外${MIN_BNB_BALANCE} BNB作为余量)`);
      
      // 寻找余额充足的钱包
      const sufficientWallets = wallets.filter(w => 
        w.address !== walletNeedsFunds.address && 
        parseFloat(w.bnbBalance) > amountNeeded + MIN_BNB_BALANCE * 2
      );
      
      if (sufficientWallets.length === 0) {
        console.log(`没有找到余额足够的钱包为 ${walletNeedsFunds.address} 提供 ${amountNeeded} BNB`);
        return false;
      }
      
      // 选择余额最多的钱包
      const donorWallet = sufficientWallets.reduce((prev, current) => 
        parseFloat(prev.bnbBalance) > parseFloat(current.bnbBalance) ? prev : current
      );
      
      console.log(`自动为钱包 ${walletNeedsFunds.address} 从 ${donorWallet.address} 转入 ${amountNeeded} BNB`);
      
      // 执行转账
      await transferBetweenWallets(donorWallet, walletNeedsFunds, amountNeeded);
      
      return true;
    } catch (err) {
      console.error("自动余额补充失败:", err);
      return false;
    }
  };

  // 添加用于钱包间余额转账的函数
  const transferBetweenWallets = async (fromWallet, toWallet, amount) => {
    if (!provider) return;
    try {
      setLoading(true);
      
      // 格式化转账金额，最多保留8位小数，避免精度问题
      const formattedAmount = parseFloat(amount).toFixed(8);
      console.log(`格式化的转账金额: ${formattedAmount} BNB`);
      
      const walletSigner = new ethers.Wallet(fromWallet.privateKey, provider);
      const tx = await walletSigner.sendTransaction({
        to: toWallet.address,
        value: ethers.parseEther(formattedAmount)
      });
      
      await tx.wait();
      
      // 更新钱包余额
      await fetchWalletsBalances(wallets);
      
      // 记录转账交易
      const txRecord = {
        wallet: fromWallet.address,
        type: '内部转账',
        spentAmount: formattedAmount,
        spentSymbol: 'BNB',
        receivedAmount: '',
        receivedSymbol: '',
        txHash: tx.hash,
        explorerUrl: `https://bscscan.com/tx/${tx.hash}`,
        timestamp: new Date().toLocaleString(),
        status: '已完成',
        note: `转账至 ${toWallet.address.slice(0, 6)}...${toWallet.address.slice(-4)}`
      };
      
      setTxHistory(prev => [txRecord, ...prev]);
      setError(null);
    } catch (err) {
      console.error("钱包间转账失败:", err);
      setError(`转账失败: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };
  
  // 检查钱包余额并自动转账的函数
  const checkAndRebalanceWallets = async () => {
    if (wallets.length < 2 || !adminMode) {
      setError("需要至少两个钱包且需要管理员权限");
      return;
    }
    
    try {
      setLoading(true);
      
      // 找出BNB余额足够的钱包和余额不足的钱包
      const MIN_BNB_BALANCE = 0.005; // 最小BNB余额阈值
      const TARGET_BNB_BALANCE = 0.01; // 目标BNB余额
      
      const sufficientWallets = wallets.filter(w => parseFloat(w.bnbBalance) > MIN_BNB_BALANCE * 2);
      const insufficientWallets = wallets.filter(w => parseFloat(w.bnbBalance) < MIN_BNB_BALANCE);
      
      if (insufficientWallets.length === 0) {
        setError("所有钱包余额均足够");
        setLoading(false);
        return;
      }
      
      if (sufficientWallets.length === 0) {
        setError("没有余额足够的钱包可用于转账");
        setLoading(false);
        return;
      }
      
      // 使用对话框而不是全局confirm
      setPendingAction({
        type: 'rebalance',
        sufficientWallets,
        insufficientWallets,
        MIN_BNB_BALANCE,
        TARGET_BNB_BALANCE
      });
      setShowConfirmDialog(true);
      setLoading(false);
    } catch (err) {
      console.error("余额重新分配失败:", err);
      setError(`余额重新分配失败: ${err.message}`);
      setLoading(false);
    }
  };

  // 执行余额重新分配的函数
  const executeRebalance = async (action) => {
    try {
      setLoading(true);
      const { sufficientWallets, insufficientWallets, MIN_BNB_BALANCE, TARGET_BNB_BALANCE } = action;
      
      let donorIndex = 0;
      for (const insufficientWallet of insufficientWallets) {
        const fromWallet = sufficientWallets[donorIndex % sufficientWallets.length];
        const amount = parseFloat((TARGET_BNB_BALANCE - parseFloat(insufficientWallet.bnbBalance)).toFixed(8));
        
        if (amount > 0 && parseFloat(fromWallet.bnbBalance) > amount + MIN_BNB_BALANCE) {
          await transferBetweenWallets(fromWallet, insufficientWallet, amount);
          donorIndex++;
        }
      }
      
      setError(null);
    } catch (err) {
      console.error("余额重新分配失败:", err);
      setError(`余额重新分配失败: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const processBuyTransaction = async (wallet, amount, currentIndex, totalCount, isVolumeTrade = false, customSlippage = null) => {
    try {
      // 首先处理金额格式，避免科学计数法
      const formattedAmount = typeof amount === 'number' 
        ? amount.toLocaleString('fullwide', { useGrouping: false, minimumFractionDigits: 0, maximumFractionDigits: 18 })
        : amount;

      console.log(`开始处理${isVolumeTrade ? '刷量' : '批量'}买入交易，钱包: ${wallet.address}，买入金额: ${formattedAmount} BNB`);
      
      // 确保金额格式正确
      let buyAmount;
      try {
        // 使用 parseUnits 而不是 parseEther 来确保精确计算
        buyAmount = ethers.parseUnits(formattedAmount, 18);
        if (buyAmount === 0n) {
          throw new Error('金额不能为0');
        }
        console.log(`格式化后的买入金额: ${ethers.formatUnits(buyAmount, 18)} BNB`);
      } catch (err) {
        console.error('金额格式化失败:', err);
        throw new Error(`无效的买入金额: ${formattedAmount}`);
      }

      // 获取 gas 信息
      let gasPrice, gasLimit;
      try {
        const feeData = await provider.getFeeData();
        gasPrice = feeData.maxFeePerGas || (feeData.gasPrice * 120n) / 100n;
        
        try {
          const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
          const contract = new ethers.Contract(SWAP_CONTRACT_ADDRESS, SWAP_CONTRACT_ABI, walletSigner);
          gasLimit = await contract.buyTokenAMAP.estimateGas(
            tokenAddress,
            buyAmount,
            0n,
            { value: buyAmount }
          );
          gasLimit = (gasLimit * 120n) / 100n;
        } catch {
          gasLimit = 500000n;
        }
      } catch {
        gasPrice = ethers.parseUnits("5", "gwei");
        gasLimit = 500000n;
      }

      // 检查余额
      const walletBalance = await provider.getBalance(wallet.address);
      const estimatedGasCost = gasPrice * gasLimit;
      const totalRequired = buyAmount + estimatedGasCost;

      if (walletBalance < totalRequired) {
        const shortfall = ethers.formatEther(totalRequired - walletBalance);
        console.log(`余额不足，差额: ${shortfall} BNB`);
        
        const transferSuccess = await checkAndAutoRebalanceWallet(
          wallet, 
          parseFloat(shortfall) + 0.001
        );
        
        if (!transferSuccess) {
          throw new Error(`余额不足且无法自动补充`);
        }

        const newBalance = await provider.getBalance(wallet.address);
        if (newBalance < totalRequired) {
          throw new Error(`补充后余额仍然不足`);
        }
      }

      // 计算预期收到的代币数量
      const expectedTokens = await calculateExpectedBuyAmount(buyAmount);
      const slippagePercent = parseFloat(customSlippage || (isVolumeTrade ? volumeBuySlippage : buySlippage));
      const minTokens = expectedTokens * BigInt(Math.floor((100 - slippagePercent) * 100)) / 10000n;

      // 准备交易参数
      const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
      const contract = new ethers.Contract(SWAP_CONTRACT_ADDRESS, SWAP_CONTRACT_ABI, walletSigner);
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      const beforeTokenBalance = await tokenContract.balanceOf(wallet.address);

      const txParams = {
        value: buyAmount,
        gasLimit: gasLimit,
        gasPrice: gasPrice,
        nonce: await provider.getTransactionCount(wallet.address)
      };

      // 执行交易
      setActiveTx({
        wallet: wallet.address,
        type: '买入',
        amount: `${formattedAmount} BNB`,
        status: '交易中',
        index: currentIndex,
        total: totalCount
      });

      const tx = await contract.buyTokenAMAP(
        tokenAddress,
        buyAmount,
        minTokens,
        txParams
      );

      console.log(`交易已发送: ${tx.hash}`);
      setActiveTx(prev => ({...prev, status: '等待确认'}));

      const receipt = await tx.wait();
      
      if (receipt.status === 1) {
        const afterTokenBalance = await tokenContract.balanceOf(wallet.address);
        const receivedTokens = afterTokenBalance - beforeTokenBalance;
        
        if (receivedTokens < minTokens) {
          throw new Error(`收到的代币数量小于最小预期值`);
        }

        const txRecord = {
          wallet: wallet.address,
          type: '买入',
          spentAmount: formattedAmount,
          spentSymbol: 'BNB',
          receivedAmount: ethers.formatUnits(receivedTokens, tokenInfo.decimals),
          receivedSymbol: tokenInfo.symbol,
          txHash: tx.hash,
          explorerUrl: `https://bscscan.com/tx/${tx.hash}`,
          timestamp: new Date().toLocaleString(),
          status: '已完成',
          isVolumeTrade
        };
        
        setTxHistory(prev => [txRecord, ...prev]);
        return true;
      } else {
        throw new Error("交易失败");
      }
    } catch (err) {
      console.error(`买入交易失败:`, err);
      setTxHistory(prev => [{
        wallet: wallet.address,
        type: '买入',
        spentAmount: amount,
        spentSymbol: 'BNB',
        error: err.message,
        timestamp: new Date().toLocaleString(),
        status: '失败'
      }, ...prev]);
      return false;
    }
  };

  const processSellTransaction = async (wallet, tokenAmount, currentIndex, totalCount, isVolumeTrade = false, customSlippage = null) => {
    try {
      // 判断是百分比模式还是固定数量模式
      const isSellPercentMode = typeof tokenAmount === 'string' && tokenAmount.includes('%');
      const percentAmount = isSellPercentMode ? parseFloat(tokenAmount.replace('%', '')) : null;
      
      console.log(`开始处理${isVolumeTrade ? '刷量' : '批量'}卖出交易，钱包: ${wallet.address}，${isSellPercentMode ? 
        `卖出比例: ${percentAmount}%` : 
        `卖出数量: ${tokenAmount} ${tokenInfo.symbol}`}`);
      
      // 获取钱包当前代币余额
      const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
      const currentBalance = await tokenContract.balanceOf(wallet.address);
      console.log(`当前代币余额: ${ethers.formatUnits(currentBalance, tokenInfo.decimals)} ${tokenInfo.symbol}`);
      
      if (currentBalance === 0n) {
        console.log(`钱包 ${wallet.address} 没有${tokenInfo.symbol}余额，跳过交易`);
        return false;
      }
      
      // 检查BNB余额是否足够支付交易费用
      const walletBnbBalance = await provider.getBalance(wallet.address);
      const formattedBnbBalance = ethers.formatEther(walletBnbBalance);
      console.log(`钱包BNB余额: ${formattedBnbBalance} BNB`);
      
      // 预估所需的最小BNB余额(0.001 BNB 应该足够支付gas费)
      const MIN_REQUIRED_BNB = 0.001;
      
      if (parseFloat(formattedBnbBalance) < MIN_REQUIRED_BNB) {
        console.log(`钱包BNB余额不足，需要至少 ${MIN_REQUIRED_BNB} BNB 支付交易费`);
        console.log(`尝试自动转入BNB...`);
        
        // 尝试从其他钱包转入BNB
        const rebalanceSuccess = await checkAndAutoRebalanceWallet(wallet, MIN_REQUIRED_BNB);
        
        if (!rebalanceSuccess) {
          console.log(`无法为钱包 ${wallet.address} 自动转入BNB，卖出交易可能会失败`);
          // 我们仍然继续尝试交易，因为可能有足够的余额
        } else {
          console.log(`已成功为钱包 ${wallet.address} 转入BNB`);
          // 更新显示的余额
          const newBalance = await provider.getBalance(wallet.address);
          console.log(`转账后BNB余额: ${ethers.formatEther(newBalance)} BNB`);
        }
      }
      
      let amountWei;
      
      if (isSellPercentMode) {
        // 按百分比计算卖出数量
        const sellRatio = percentAmount / 100;
        console.log(`卖出比例: ${sellRatio}`);
        
        // 获取当前余额的整数部分
        const balanceStr = ethers.formatUnits(currentBalance, tokenInfo.decimals);
        console.log(`原始余额: ${balanceStr} ${tokenInfo.symbol}`);
        
        // 只保留整数部分处理 - 简单直接的方式
        const integerPart = balanceStr.split('.')[0];
        const integerAmount = ethers.parseUnits(integerPart, tokenInfo.decimals);
        
        console.log(`整数部分余额: ${integerPart} ${tokenInfo.symbol}`);
        
        // 计算卖出数量 - 只使用整数部分的百分比
        amountWei = (integerAmount * BigInt(Math.floor(sellRatio * 10000))) / 10000n;
        console.log(`按比例计算卖出数量: ${ethers.formatUnits(amountWei, tokenInfo.decimals)} ${tokenInfo.symbol}`);
      } else {
        // 直接使用固定数量 (用于刷量交易)
        // 将数量转换为Wei
        try {
          // 尝试处理数字或字符串格式
          const amount = typeof tokenAmount === 'number' ? tokenAmount.toString() : tokenAmount;
          amountWei = ethers.parseUnits(amount, tokenInfo.decimals);
          console.log(`固定数量卖出: ${amount} ${tokenInfo.symbol} (${ethers.formatUnits(amountWei, tokenInfo.decimals)})`);
        } catch (err) {
          console.error(`解析卖出数量出错:`, err);
          return false;
        }
      }
      
      // 检查是否为零
      if (amountWei === 0n) {
        console.log(`计算的卖出数量为零，无法继续交易`);
        return false;
      }
      
      // 确保不超过余额
      if (amountWei > currentBalance) {
        console.log(`计算的卖出数量 ${ethers.formatUnits(amountWei, tokenInfo.decimals)} 超过余额 ${ethers.formatUnits(currentBalance, tokenInfo.decimals)}，调整为全部余额`);
        amountWei = currentBalance;
      }
      
      // 格式化为可读数字用于日志和显示
      const formattedAmount = ethers.formatUnits(amountWei, tokenInfo.decimals);
      console.log(`执行卖出: ${formattedAmount} ${tokenInfo.symbol}`);
      
      // 创建签名者
      const walletSigner = new ethers.Wallet(wallet.privateKey, provider);
      
      // 获取合约实例
      const contract = new ethers.Contract(SWAP_CONTRACT_ADDRESS, SWAP_CONTRACT_ABI, walletSigner);
      const signerTokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, walletSigner);
      
      // 设置当前活动交易
      setActiveTx({
        wallet: wallet.address,
        type: '卖出',
        amount: `${formattedAmount} ${tokenInfo.symbol}`,
        status: '检查授权中',
        index: currentIndex,
        total: totalCount,
        isVolumeTrade // 添加标识来区分刷量交易
      });

      // 检查代币授权
      console.log(`检查代币授权状态...`);
      const currentAllowance = await signerTokenContract.allowance(wallet.address, SWAP_CONTRACT_ADDRESS);
      console.log(`当前授权额度: ${ethers.formatUnits(currentAllowance, tokenInfo.decimals)} ${tokenInfo.symbol}`);
      
      // 如果授权额度不足，先进行授权
      if (currentAllowance < amountWei) {
        console.log(`授权额度不足，需要重新授权...`);
        console.log(`需要授权数量: ${ethers.formatUnits(amountWei, tokenInfo.decimals)} ${tokenInfo.symbol}`);
        
        setActiveTx(prev => ({
          ...prev,
          status: '正在授权'
        }));
        
        try {
          // 使用最大值进行授权，避免后续需要重复授权
          const maxUint256 = ethers.MaxUint256;
          console.log(`发起授权交易，授权金额: 最大值`);
          
          // 先检查当前gas价格
          const gasPrice = await provider.getFeeData();
          console.log(`当前gas价格: ${ethers.formatUnits(gasPrice.gasPrice, 'gwei')} gwei`);
          
          const approveTx = await signerTokenContract.approve(SWAP_CONTRACT_ADDRESS, maxUint256, {
            gasLimit: 100000,
            gasPrice: gasPrice.gasPrice
          });
          
          console.log(`授权交易已发送，等待确认: ${approveTx.hash}`);
          setActiveTx(prev => ({
            ...prev,
            status: '等待授权确认'
          }));
          
          const approveReceipt = await approveTx.wait();
          
          if (approveReceipt.status === 1) {
            console.log(`授权交易已确认，交易成功`);
            
            // 等待3秒，确保授权已经生效
            console.log('等待3秒确保授权生效...');
            await new Promise(resolve => setTimeout(resolve, 3000));
            
            // 再次检查授权额度
            const newAllowance = await signerTokenContract.allowance(wallet.address, SWAP_CONTRACT_ADDRESS);
            console.log(`新授权额度: ${ethers.formatUnits(newAllowance, tokenInfo.decimals)} ${tokenInfo.symbol}`);
            
            if (newAllowance < amountWei) {
              throw new Error(`授权失败，新授权额度仍然不足`);
            }
          } else {
            throw new Error(`授权交易失败`);
          }
        } catch (approveErr) {
          console.error(`授权过程出错:`, approveErr);
          throw new Error(`代币授权失败: ${approveErr.message}`);
        }
      } else {
        console.log(`当前授权额度充足，可以继续交易`);
      }
      
      // 获取预期收到的资金和最小资金（考虑滑点）
      setActiveTx(prev => ({
        ...prev,
        status: '计算交易参数'
      }));
      
      // 计算预期收到的BNB数量
      console.log(`计算预期收到的BNB...`);
      let expectedFunds;
      try {
        expectedFunds = await calculateExpectedSellAmount(amountWei);
        console.log(`预期收到: ${ethers.formatEther(expectedFunds)} BNB`);
        
        // 确保预期BNB金额不超过1 BNB（安全检查）
        if (expectedFunds > ethers.parseEther("1")) {
          console.log(`预期BNB金额过大，调整为更合理的值`);
          // 使用代币数量 * 当前价格的简单计算
          const numTokenAmount = parseFloat(formattedAmount);
          let priceValue = priceInfo.price;
          if (priceValue.includes('e')) {
            const numValue = parseFloat(priceValue);
            priceValue = numValue.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 18 });
          }
          const price = parseFloat(priceValue);
          const recalculatedBnb = numTokenAmount * price;
          console.log(`重新计算: ${numTokenAmount} * ${price} = ${recalculatedBnb} BNB`);
          
          expectedFunds = ethers.parseEther(recalculatedBnb.toFixed(18));
          console.log(`调整后预期收到: ${ethers.formatEther(expectedFunds)} BNB`);
        }
      } catch (err) {
        console.error("预期金额计算失败，使用估算值:", err);
        // 如果预期金额计算失败，使用估算值（假设1BNB=1亿代币）
        expectedFunds = amountWei * ethers.parseEther("1") / ethers.parseUnits("100000000", tokenInfo.decimals);
        console.log(`使用估算预期收到金额: ${ethers.formatEther(expectedFunds)} BNB`);
      }
      
      // 使用传入的自定义滑点或根据交易类型选择默认滑点
      const slippagePercent = parseFloat(customSlippage || (isVolumeTrade ? volumeSellSlippage : sellSlippage));
      console.log(`使用卖出滑点: ${slippagePercent}% ${customSlippage ? '(自定义)' : isVolumeTrade ? '(刷量)' : '(批量)'}`);
      
      // 使用BigInt计算最小BNB值
      const minFundsWei = expectedFunds * BigInt(Math.floor((100 - slippagePercent) * 100)) / 10000n;
      console.log(`最低接受: ${ethers.formatEther(minFundsWei)} BNB (滑点: ${slippagePercent}%)`);
      
      // 确保minFunds不为0
      const minFunds = minFundsWei > 0n ? minFundsWei : ethers.parseEther("0.0000001");
      console.log(`最终最低接受: ${ethers.formatEther(minFunds)} BNB`);
      
      // 记录交易前余额
      const beforeBnbBalance = await provider.getBalance(wallet.address);
      console.log(`交易前BNB余额: ${ethers.formatEther(beforeBnbBalance)} BNB`);
      
      // 执行卖出交易
      setActiveTx(prev => ({
        ...prev,
        status: '执行卖出交易'
      }));
      
      // 获取并调整gas价格
      let gasPrice, gasLimit;
      
      if (customGasEnabled) {
        // 使用用户自定义的GAS设置
        gasPrice = ethers.parseUnits(customGasPrice, 'gwei');
        gasLimit = BigInt(customGasLimit);
        console.log(`使用自定义gas: 价格=${ethers.formatUnits(gasPrice, 'gwei')} gwei, 限制=${gasLimit}`);
      } else {
        // 使用网络建议的gas价格并增加20%
        const sellGasPrice = await provider.getFeeData();
        gasPrice = sellGasPrice.gasPrice * 120n / 100n; // 提高20%
        gasLimit = 600000n;
        console.log(`当前gas价格: ${ethers.formatUnits(sellGasPrice.gasPrice, 'gwei')} gwei, 调整后: ${ethers.formatUnits(gasPrice, 'gwei')} gwei`);
      }
      
      // 准备卖出交易参数
      const txParams = {
        gasLimit: gasLimit,
        gasPrice: gasPrice
      };
      
      console.log('卖出交易参数:', {
        token: tokenAddress,
        amount: ethers.formatUnits(amountWei, tokenInfo.decimals),
        minFunds: ethers.formatEther(minFunds),
        gasPrice: ethers.formatUnits(gasPrice, 'gwei'),
        gasLimit: gasLimit
      });
      
      // 执行卖出交易
      console.log(`开始发送卖出交易...`);
      const tx = await contract.sellToken(
        tokenAddress,
        amountWei,
        minFunds,
        txParams
      );
      
      console.log(`交易已发送，等待确认: ${tx.hash}`);
      setActiveTx(prev => ({
        ...prev,
        status: '等待交易确认'
      }));
      
      // 等待交易确认
      const receipt = await tx.wait();
      console.log(`交易已确认，区块号: ${receipt.blockNumber}`);
      
      if (receipt.status === 1) {
        console.log('交易成功');
        
        // 获取交易后余额并计算收益
        const afterBnbBalance = await provider.getBalance(wallet.address);
        const receivedBnb = ethers.formatEther(
          BigInt(afterBnbBalance.toString()) - BigInt(beforeBnbBalance.toString())
        );
        
        console.log(`交易后BNB余额: ${ethers.formatEther(afterBnbBalance)} BNB`);
        console.log(`实际收到BNB: ${receivedBnb} BNB`);
        
        // 记录交易
        const txRecord = {
          wallet: wallet.address,
          type: '卖出',
          spentAmount: formattedAmount,
          spentSymbol: tokenInfo.symbol,
          receivedAmount: receivedBnb,
          receivedSymbol: 'BNB',
          txHash: tx.hash,
          explorerUrl: `https://bscscan.com/tx/${tx.hash}`,
          timestamp: new Date().toLocaleString(),
          status: '已完成',
          isVolumeTrade // 添加标识来区分刷量交易
        };
        
        setTxHistory(prev => [txRecord, ...prev]);
        
        // 更新钱包余额
        const updatedWallet = {
          ...wallet,
          bnbBalance: (parseFloat(wallet.bnbBalance) + parseFloat(receivedBnb)).toFixed(6),
          tokenBalance: (parseFloat(wallet.tokenBalance) - parseFloat(formattedAmount)).toFixed(6)
        };
        
        setWallets(prev => prev.map(w => w.address === wallet.address ? updatedWallet : w));
        return true;
      } else {
        console.log('交易失败');
        throw new Error('交易状态为失败');
      }
    } catch (err) {
      // 处理所有错误
      console.error(`钱包 ${wallet.address} 卖出交易失败:`, err);
      
      // 尝试创建一个用于显示的金额字符串，确保formattedAmount有一个值
      let displayAmount;
      if (typeof tokenAmount === 'string' && tokenAmount.includes('%')) {
        // 如果是百分比格式，直接使用
        displayAmount = tokenAmount;
      } else {
        try {
          // 尝试格式化金额，不依赖amountWei
          if (typeof tokenAmount === 'number' || !isNaN(parseFloat(tokenAmount))) {
            // 如果是数字或可解析为数字的字符串
            displayAmount = `${tokenAmount} ${tokenInfo.symbol}`;
          } else {
            // 默认情况
            displayAmount = `未知数量 ${tokenInfo.symbol}`;
          }
        } catch (e) {
          // 如果格式化失败，使用原始输入
          displayAmount = `${tokenAmount} ${tokenInfo.symbol}`;
        }
      }
      
      // 记录失败交易
      setTxHistory(prev => [{
        wallet: wallet.address,
        type: '卖出',
        spentAmount: displayAmount,
        spentSymbol: tokenInfo.symbol,
        error: err.message,
        timestamp: new Date().toLocaleString(),
        status: '失败',
        isVolumeTrade
      }, ...prev]);
      
      return false;
    } finally {
      setActiveTx(null);
    }
  };

  const runVolumeTrade = async () => {
    console.log("========== 刷量交易开始执行 ==========");
    
    if (!adminMode) {
      setError("需要管理员权限");
      return;
    }

    if (!provider || selectedWallets.length === 0) {
      setError("请选择至少一个钱包");
      return;
    }

    if (!tokenAddress || !ethers.isAddress(tokenAddress)) {
      setError("请输入有效的代币地址");
      return;
    }

    if (!ethers.isAddress(SWAP_CONTRACT_ADDRESS)) {
      setError("合约地址无效");
      return;
    }
    
    // 检查交易轮次设置
    if (volumeRounds <= 0) {
      console.log("交易轮次设置为0或负数，自动设置为1轮");
      volumeRounds = 1;
    }

    // 显示UI状态
    setVolumeTradeStatus({
      isRunning: true,
      currentRound: 0,
      totalRounds: volumeRounds,
      currentAction: '刷量交易准备开始',
      processedCount: 0,
      totalCount: selectedWallets.length
    });
    
    // 显示刷量交易的配置信息
    console.log(`代币地址: ${tokenAddress}`);
    console.log(`合约地址: ${SWAP_CONTRACT_ADDRESS}`);
    console.log(`交易轮次: ${volumeRounds}`);

    setLoading(true);
    setError(null);
    setIsVolumeTrading(true);
    setCurrentRound(0);

    try {
      // 检查provider连接状态
      const blockNumber = await provider.getBlockNumber();
      console.log(`当前区块高度: ${blockNumber}`);
      setVolumeTradeStatus(prev => ({...prev, currentAction: `检查网络连接，当前区块高度: ${blockNumber}`}));
      
      // 获取选中的钱包对象
      const selectedWalletObjects = wallets.filter(w => selectedWallets.includes(w.address));
      console.log(`选中的钱包数量: ${selectedWalletObjects.length}`);
      console.log("选中的钱包地址:", selectedWalletObjects.map(w => w.address));
      setVolumeTradeStatus(prev => ({...prev, currentAction: `已选择 ${selectedWalletObjects.length} 个钱包`}));
      
      // 检查钱包数量是否足够进行买卖交易
      if (selectedWalletObjects.length < 2) {
        console.log("警告：钱包数量少于2个，无法同时进行买卖交易");
        setVolumeTradeStatus(prev => ({...prev, currentAction: `警告：钱包数量少于2个，无法同时进行买卖交易`}));
      }
      
      // 买卖金额设置
      const buyAmountValue = useVolumeRandomAmount ? 
        getRandomAmount(volumeAmountRange.min, volumeAmountRange.max) : 
        parseFloat(volumeBuyAmount);
      
      // 卖出使用金额而不是百分比
      const sellAmountValue = useVolumeRandomSellAmount ? 
        getRandomAmount(volumeSellAmountRange.min, volumeSellAmountRange.max) : 
        parseFloat(volumeBuyAmount); // 使用与买入相同的金额进行卖出
      
      console.log(`买入金额: ${buyAmountValue} BNB`);
      console.log(`卖出金额: ${sellAmountValue} BNB 等值代币`);
      console.log(`买入比例: ${buyPercentage}%`);
      console.log(`卖出比例: ${sellPercentage}%`);
      console.log(`买入滑点: ${volumeBuySlippage}%`);
      console.log(`卖出滑点: ${volumeSellSlippage}%`);
      
      setVolumeTradeStatus(prev => ({
        ...prev, 
        currentAction: `交易配置: 买入金额=${buyAmountValue} BNB, 卖出=${sellAmountValue} BNB等值代币, 买入滑点=${volumeBuySlippage}%, 卖出滑点=${volumeSellSlippage}%`
      }));
      
      // 检查所有钱包的BNB余额
      for (const wallet of selectedWalletObjects) {
        const balance = await getBNBBalance(provider, wallet.address);
        console.log(`钱包 ${wallet.address} BNB余额: ${balance} BNB`);
        setVolumeTradeStatus(prev => ({
          ...prev, 
          currentAction: `检查钱包余额: ${wallet.address.substring(0, 6)}...${wallet.address.slice(-4)}: ${balance} BNB`
        }));
      }
      
      // 开始执行交易循环
      console.log("===== 开始执行交易循环 =====");
      setVolumeTradeStatus(prev => ({...prev, currentAction: `开始执行交易循环`}));
      let txSuccess = false; // 跟踪是否有任何交易成功
      
      // 执行直接的买卖交易
      console.log("===== 开始执行直接买卖交易 =====");
      
      // 1. 分配钱包：根据买入/卖出比例分配
      const totalWallets = selectedWalletObjects.length;
      const buyCount = Math.max(1, Math.floor(totalWallets * buyPercentage / 100));
      const sellCount = totalWallets - buyCount;
      
      const buyWallets = selectedWalletObjects.slice(0, buyCount);
      const sellWallets = selectedWalletObjects.slice(buyCount);
      
      console.log(`总钱包数: ${totalWallets}`);
      console.log(`买入钱包数: ${buyWallets.length}, 买入钱包: ${buyWallets.map(w => w.address).join(', ')}`);
      console.log(`卖出钱包数: ${sellWallets.length}, 卖出钱包: ${sellWallets.map(w => w.address).join(', ')}`);
      
      setVolumeTradeStatus(prev => ({
        ...prev, 
        currentAction: `钱包分配: ${buyWallets.length}个买入, ${sellWallets.length}个卖出`,
        processedCount: 0,
        totalCount: totalWallets
      }));
      
      // 2. 执行买入交易
      let processedCount = 0;
      
      if (buyWallets.length > 0) {
        console.log("===== 开始执行买入交易 =====");
        setVolumeTradeStatus(prev => ({...prev, currentAction: `开始执行买入交易`}));
        
        // 根据刷量交易独立的顺序执行设置决定执行方式
        if (volumeBuySequentialMode) {
          // 顺序执行买入交易
          console.log("使用顺序执行模式买入");
          
          for (let i = 0; i < buyWallets.length; i++) {
            const wallet = buyWallets[i];
            console.log(`===== 执行买入交易 ${i+1}/${buyWallets.length} =====`);
            
            // 更新UI显示当前处理的钱包和进度
            const shortAddr = `${wallet.address.substring(0, 6)}...${wallet.address.slice(-4)}`;
            setVolumeTradeStatus(prev => ({
              ...prev,
              currentAction: `买入交易 (${i+1}/${buyWallets.length}): ${shortAddr}`,
              processedCount,
              walletAddress: wallet.address
            }));
            
            try {
              // 设置买入金额
              const buyAmount = useVolumeRandomBuyAmount ? 
                getRandomAmount(volumeBuyAmountRange.min, volumeBuyAmountRange.max) : 
                buyAmountValue;
              
              console.log(`钱包地址: ${wallet.address}`);
              console.log(`买入金额: ${buyAmount} BNB`);
              console.log(`代币地址: ${tokenAddress}`);
              
              // 执行买入交易
              console.log(`调用买入函数 processBuyTransaction...`);
              
              // 显示交易处理状态
              setVolumeTradeStatus(prev => ({
                ...prev,
                currentAction: `买入交易 (${i+1}/${buyWallets.length}): ${shortAddr}, 金额: ${buyAmount} BNB, 滑点: ${volumeBuySlippage}%`,
                status: '处理中'
              }));
              
              // 传递刷量交易标记和独立滑点
              const result = await processBuyTransaction(wallet, buyAmount, i+1, buyWallets.length, true, volumeBuySlippage);
              
              if (result) {
                console.log(`买入交易成功: ${wallet.address}`);
                processedCount++;
                txSuccess = true;
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `买入交易成功 (${i+1}/${buyWallets.length}): ${shortAddr}`,
                  processedCount,
                  status: '成功'
                }));
              } else {
                console.log(`买入交易失败: ${wallet.address}`);
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `买入交易失败 (${i+1}/${buyWallets.length}): ${shortAddr}`,
                  status: '失败'
                }));
              }
              
              // 等待间隔
              if (i < buyWallets.length - 1) {
                console.log(`等待 ${volumeBuyDelayBetweenTx} 秒后执行下一笔买入...`);
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `等待 ${volumeBuyDelayBetweenTx} 秒后执行下一笔买入交易...`,
                  status: '等待中'
                }));
                
                await new Promise(resolve => setTimeout(resolve, volumeBuyDelayBetweenTx * 1000));
              }
            } catch (err) {
              console.error(`买入交易错误:`, err);
              setError(`买入交易错误: ${err.message}`);
              
              setVolumeTradeStatus(prev => ({
                ...prev,
                currentAction: `买入交易出错 (${i+1}/${buyWallets.length}): ${shortAddr}, 错误: ${err.message}`,
                status: '错误'
              }));
            }
          }
        } else {
          // 并行执行买入交易
          console.log("使用并行执行模式买入");
          
          setVolumeTradeStatus(prev => ({
            ...prev,
            currentAction: `并行执行买入交易 (${buyWallets.length}个钱包)`,
            status: '处理中'
          }));
          
          const buyPromises = buyWallets.map((wallet, index) => {
            const buyAmount = useVolumeRandomBuyAmount ? 
              getRandomAmount(volumeBuyAmountRange.min, volumeBuyAmountRange.max) : 
              buyAmountValue;
              
            console.log(`准备买入交易: 钱包=${wallet.address}, 金额=${buyAmount} BNB`);
            return processBuyTransaction(wallet, buyAmount, index+1, buyWallets.length, true, volumeBuySlippage);
          });
          
          const buyResults = await Promise.all(buyPromises);
          const successCount = buyResults.filter(result => result === true).length;
          
          console.log(`买入交易完成，成功: ${successCount}/${buyWallets.length}`);
          processedCount += successCount;
          
          if (successCount > 0) {
            txSuccess = true;
          }
          
          setVolumeTradeStatus(prev => ({
            ...prev,
            currentAction: `买入交易完成，成功: ${successCount}/${buyWallets.length}`,
            processedCount,
            status: '完成'
          }));
        }
      }
      
      // 买卖之间等待
      if (buyWallets.length > 0 && sellWallets.length > 0) {
        console.log(`买卖交易之间等待 5 秒...`);
        
        setVolumeTradeStatus(prev => ({
          ...prev,
          currentAction: `买卖交易之间等待 5 秒...`,
          status: '等待中'
        }));
        
        await new Promise(resolve => setTimeout(resolve, 5000));
      }
      
      // 3. 执行卖出交易 - 这里使用金额而非百分比
      if (sellWallets.length > 0) {
        console.log("===== 开始执行卖出交易 =====");
        
        setVolumeTradeStatus(prev => ({
          ...prev,
          currentAction: `开始执行卖出交易`,
          status: '进行中'
        }));
        
        // 先检查所有卖出钱包的BNB余额，确保有足够的交易费
        console.log("检查所有卖出钱包的BNB余额...");
        setVolumeTradeStatus(prev => ({
          ...prev,
          currentAction: `检查所有卖出钱包的BNB余额`,
          status: '检查中'
        }));
        
        const MIN_REQUIRED_BNB = 0.001; // 最小需要的BNB余额
        let balanceCheckPromises = [];
        
        for (const wallet of sellWallets) {
          balanceCheckPromises.push((async () => {
            try {
              const balance = await provider.getBalance(wallet.address);
              const formattedBalance = ethers.formatEther(balance);
              console.log(`钱包 ${wallet.address} BNB余额: ${formattedBalance} BNB`);
              
              if (parseFloat(formattedBalance) < MIN_REQUIRED_BNB) {
                console.log(`钱包 ${wallet.address} BNB余额不足，尝试补充...`);
                await checkAndAutoRebalanceWallet(wallet, MIN_REQUIRED_BNB);
              }
            } catch (err) {
              console.error(`检查钱包余额出错:`, err);
            }
          })());
        }
        
        // 等待所有余额检查和转账完成
        await Promise.all(balanceCheckPromises);
        console.log("所有钱包BNB余额检查完成");
        
        // 根据刷量交易独立的顺序执行设置决定执行方式
        if (volumeSellSequentialMode) {
          // 顺序执行卖出交易
          console.log("使用顺序执行模式卖出");
          
          for (let i = 0; i < sellWallets.length; i++) {
            const wallet = sellWallets[i];
            console.log(`===== 执行卖出交易 ${i+1}/${sellWallets.length} =====`);
            
            // 更新UI显示当前处理的钱包和进度
            const shortAddr = `${wallet.address.substring(0, 6)}...${wallet.address.slice(-4)}`;
            setVolumeTradeStatus(prev => ({
              ...prev,
              currentAction: `卖出交易 (${i+1}/${sellWallets.length}): ${shortAddr}`,
              processedCount,
              walletAddress: wallet.address
            }));
            
            try {
              // 检查代币余额
              const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
              const tokenBalance = await tokenContract.balanceOf(wallet.address);
              const formattedBalance = ethers.formatUnits(tokenBalance, tokenInfo.decimals);
              console.log(`钱包代币余额: ${formattedBalance} ${tokenInfo.symbol}`);
              
              if (tokenBalance === 0n) {
                console.log(`钱包没有代币余额，跳过卖出`);
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `卖出交易跳过 (${i+1}/${sellWallets.length}): ${shortAddr}, 没有代币余额`,
                  status: '跳过'
                }));
                
                continue;
              }
              
              // 设置要卖出的代币固定数量
              const sellAmount = useVolumeRandomSellAmount ? 
                getRandomAmount(volumeSellAmountRange.min, volumeSellAmountRange.max).toFixed(tokenInfo.decimals) : 
                volumeSellAmount || "10"; // 默认卖出10个代币
              
              console.log(`钱包地址: ${wallet.address}`);
              console.log(`卖出数量: ${sellAmount} ${tokenInfo.symbol}`);
              console.log(`代币地址: ${tokenAddress}`);
              
              // 执行卖出交易
              console.log(`调用卖出函数 processSellTransaction...`);
              
              setVolumeTradeStatus(prev => ({
                ...prev,
                currentAction: `卖出交易 (${i+1}/${sellWallets.length}): ${shortAddr}, 数量: ${sellAmount} ${tokenInfo.symbol}, 滑点: ${volumeSellSlippage}%`,
                status: '处理中'
              }));
              
              // 传递固定数量、卷量交易标记和独立滑点
              const result = await processSellTransaction(wallet, sellAmount, i+1, sellWallets.length, true, volumeSellSlippage);
              
              if (result) {
                console.log(`卖出交易成功: ${wallet.address}`);
                processedCount++;
                txSuccess = true;
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `卖出交易成功 (${i+1}/${sellWallets.length}): ${shortAddr}`,
                  processedCount,
                  status: '成功'
                }));
              } else {
                console.log(`卖出交易失败: ${wallet.address}`);
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `卖出交易失败 (${i+1}/${sellWallets.length}): ${shortAddr}`,
                  status: '失败'
                }));
              }
              
              // 等待间隔
              if (i < sellWallets.length - 1) {
                console.log(`等待 ${volumeSellDelayBetweenTx} 秒后执行下一笔卖出...`);
                
                setVolumeTradeStatus(prev => ({
                  ...prev,
                  currentAction: `等待 ${volumeSellDelayBetweenTx} 秒后执行下一笔卖出交易...`,
                  status: '等待中'
                }));
                
                await new Promise(resolve => setTimeout(resolve, volumeSellDelayBetweenTx * 1000));
              }
            } catch (err) {
              console.error(`卖出交易错误:`, err);
              setError(`卖出交易错误: ${err.message}`);
              
              setVolumeTradeStatus(prev => ({
                ...prev,
                currentAction: `卖出交易出错 (${i+1}/${sellWallets.length}): ${shortAddr}, 错误: ${err.message}`,
                status: '错误'
              }));
            }
          }
        } else {
          // 并行执行卖出交易
          console.log("使用并行执行模式卖出");
          
          setVolumeTradeStatus(prev => ({
            ...prev,
            currentAction: `并行执行卖出交易 (${sellWallets.length}个钱包)`,
            status: '处理中'
          }));
          
          // 首先检查所有钱包的代币余额
          const balanceChecks = await Promise.all(
            sellWallets.map(async wallet => {
              const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
              const tokenBalance = await tokenContract.balanceOf(wallet.address);
              return {
                wallet,
                balance: tokenBalance,
                formattedBalance: ethers.formatUnits(tokenBalance, tokenInfo.decimals)
              };
            })
          );
          
          // 过滤出有余额的钱包
          const walletsWithBalance = balanceChecks.filter(item => item.balance > 0n);
          console.log(`有代币余额的钱包: ${walletsWithBalance.length}/${sellWallets.length}`);
          
          if (walletsWithBalance.length > 0) {
            const sellPromises = walletsWithBalance.map((item, index) => {
              const sellAmount = useVolumeRandomSellAmount ? 
                getRandomAmount(volumeSellAmountRange.min, volumeSellAmountRange.max).toFixed(tokenInfo.decimals) : 
                volumeSellAmount || "10"; // 默认卖出10个代币
                
              console.log(`准备卖出交易: 钱包=${item.wallet.address}, 余额=${item.formattedBalance}, 卖出=${sellAmount}`);
              return processSellTransaction(item.wallet, sellAmount, index+1, walletsWithBalance.length, true, volumeSellSlippage);
            });
            
            const sellResults = await Promise.all(sellPromises);
            const successCount = sellResults.filter(result => result === true).length;
            
            console.log(`卖出交易完成，成功: ${successCount}/${walletsWithBalance.length}`);
            processedCount += successCount;
            
            if (successCount > 0) {
              txSuccess = true;
            }
            
            setVolumeTradeStatus(prev => ({
              ...prev,
              currentAction: `卖出交易完成，成功: ${successCount}/${walletsWithBalance.length}`,
              processedCount,
              status: '完成'
            }));
          } else {
            console.log("没有钱包有足够的代币余额用于卖出");
            setVolumeTradeStatus(prev => ({
              ...prev,
              currentAction: `没有钱包有足够的代币余额用于卖出`,
              status: '跳过'
            }));
          }
        }
      }
      
      // 等待所有交易完成
      console.log("等待 3 秒确保所有交易都已处理...");
      
      setVolumeTradeStatus(prev => ({
        ...prev,
        currentAction: `等待 3 秒确保所有交易都已处理...`,
        status: '等待中'
      }));
      
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      // 更新状态
      setVolumeTradeStatus(prev => ({
        ...prev,
        isRunning: false,
        currentAction: txSuccess ? `刷量交易完成，成功执行 ${processedCount} 笔交易` : '刷量交易完成，但没有成功的交易',
        status: txSuccess ? '已完成' : '无交易'
      }));
      
      if (txSuccess) {
        console.log(`刷量交易成功完成，共执行 ${processedCount} 笔交易`);
      } else {
        console.log("刷量交易完成，但没有成功执行的交易");
      }
      
      console.log("========== 刷量交易执行结束 ==========");
    } catch (err) {
      console.error("刷量交易出错:", err);
      console.error("错误详情:", err.message);
      setError(`刷量交易出错: ${err.message}`);
      setVolumeTradeStatus(prev => ({
        ...prev,
        isRunning: false,
        currentAction: `出错: ${err.message}`,
        status: '错误'
      }));
    } finally {
      setLoading(false);
      setIsVolumeTrading(false);
    }
  };

  // 添加删除钱包的函数
  const deleteWallet = (address) => {
    setWallets(prevWallets => prevWallets.filter(wallet => wallet.address !== address));
    setSelectedWallets(prevSelected => prevSelected.filter(addr => addr !== address));
  };

  // 添加批量买入函数
  const batchBuyTokens = async () => {
    if (!adminMode) {
      setError("需要管理员权限");
      return;
    }

    if (!provider || selectedWallets.length === 0) {
      setError("请选择至少一个钱包");
      return;
    }

    const minAmount = useRandomBuyAmount ? buyAmountRange.min : buyAmount;
    const maxAmount = useRandomBuyAmount ? buyAmountRange.max : buyAmount;

    if (parseFloat(minAmount) <= 0 || parseFloat(maxAmount) <= 0) {
      setError("请输入有效的买入金额");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const selectedWalletObjects = wallets.filter(w => selectedWallets.includes(w.address));
      let failedWallets = []; // 存储失败的钱包
      let retryCount = 0; // 重试次数计数
      const MAX_RETRIES = 3; // 最大重试次数

      const processBatch = async (walletsToProcess) => {
        if (buySequentialMode) {
          // 顺序执行模式
          const newFailedWallets = [];
          for (let i = 0; i < walletsToProcess.length; i++) {
            const wallet = walletsToProcess[i];
            const currentBuyAmount = useRandomBuyAmount 
              ? getRandomAmount(buyAmountRange.min, buyAmountRange.max)
              : parseFloat(buyAmount);

            const success = await processBuyTransaction(wallet, currentBuyAmount, i + 1, walletsToProcess.length);
            
            if (!success) {
              newFailedWallets.push(wallet);
            }

            if (i < walletsToProcess.length - 1) {
              await new Promise(resolve => setTimeout(resolve, buyDelayBetweenTx * 1000));
            }
          }
          return newFailedWallets;
        } else {
          // 并行执行模式
          setActiveTx({
            type: '批量买入',
            status: '并行处理中',
            total: walletsToProcess.length
          });

          const results = await Promise.all(
            walletsToProcess.map((wallet, index) => {
              const currentBuyAmount = useRandomBuyAmount 
                ? getRandomAmount(buyAmountRange.min, buyAmountRange.max)
                : parseFloat(buyAmount);

              return processBuyTransaction(wallet, currentBuyAmount, index + 1, walletsToProcess.length)
                .then(success => ({ wallet, success }));
            })
          );

          return results.filter(r => !r.success).map(r => r.wallet);
        }
      };

      // 首次执行
      failedWallets = await processBatch(selectedWalletObjects);

      // 如果有失败的交易，进行重试
      while (failedWallets.length > 0 && retryCount < MAX_RETRIES) {
        retryCount++;
        console.log(`第 ${retryCount} 次重试，失败钱包数: ${failedWallets.length}`);
        
        // 更新UI显示重试状态
        setError(`正在进行第 ${retryCount} 次重试，共 ${failedWallets.length} 个失败交易`);
        
        // 重新获取价格
        await fetchPriceAndLiquidityImmediate();
        
        // 等待5秒后重试
        await new Promise(resolve => setTimeout(resolve, 5000));
        
        // 执行重试
        failedWallets = await processBatch(failedWallets);
      }

      // 最终状态报告
      if (failedWallets.length > 0) {
        setError(`完成交易，但仍有 ${failedWallets.length} 个钱包交易失败`);
      } else {
        setError(null);
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setActiveTx(null);
    }
  };

  // 添加回batchSellTokens函数
  const batchSellTokens = async () => {
    if (!adminMode) {
      setError("需要管理员权限");
      return;
    }

    if (!provider || selectedWallets.length === 0) {
      setError("请选择至少一个钱包");
      return;
    }

    const minAmount = useRandomSellAmount ? sellAmountRange.min : sellAmount;
    const maxAmount = useRandomSellAmount ? sellAmountRange.max : sellAmount;

    if (parseFloat(minAmount) <= 0 || parseFloat(maxAmount) <= 0) {
      setError("请输入有效的卖出数量");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const selectedWalletObjects = wallets.filter(w => selectedWallets.includes(w.address));
      let failedWallets = []; // 存储失败的钱包
      let retryCount = 0; // 重试次数计数
      const MAX_RETRIES = 2; // 最大重试次数
      const BATCH_SIZE = 15; // 每批处理的钱包数量
      const BATCH_DELAY = 5000; // 批次之间的延迟（毫秒）

      const processBatch = async (walletsToProcess) => {
        // 先检查所有卖出钱包的BNB余额
        console.log("检查所有卖出钱包的BNB余额...");
        const MIN_REQUIRED_BNB = 0.001;
        
        await Promise.all(walletsToProcess.map(async (wallet) => {
          try {
            const balance = await provider.getBalance(wallet.address);
            const formattedBalance = ethers.formatEther(balance);
            
            if (parseFloat(formattedBalance) < MIN_REQUIRED_BNB) {
              await checkAndAutoRebalanceWallet(wallet, MIN_REQUIRED_BNB);
            }
          } catch (err) {
            console.error(`检查钱包余额出错:`, err);
          }
        }));

        // 分批处理
        const batches = [];
        for (let i = 0; i < walletsToProcess.length; i += BATCH_SIZE) {
          batches.push(walletsToProcess.slice(i, i + BATCH_SIZE));
        }

        let allFailedWallets = [];

        for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
          const currentBatch = batches[batchIndex];
          
          if (sellSequentialMode) {
            // 顺序执行模式
            const batchFailedWallets = [];
            for (let i = 0; i < currentBatch.length; i++) {
              const wallet = currentBatch[i];
              const sellPercentParam = useRandomSellAmount 
                ? `${getRandomAmount(sellAmountRange.min, sellAmountRange.max)}%`
                : `${parseFloat(sellAmount)}%`;

              const success = await processSellTransaction(wallet, sellPercentParam, i + 1, currentBatch.length);
              
              if (!success) {
                batchFailedWallets.push(wallet);
              }

              if (i < currentBatch.length - 1) {
                await new Promise(resolve => setTimeout(resolve, sellDelayBetweenTx * 1000));
              }
            }
            allFailedWallets = [...allFailedWallets, ...batchFailedWallets];
          } else {
            // 并行执行模式
            const results = await Promise.all(
              currentBatch.map((wallet, index) => {
                const sellPercentParam = useRandomSellAmount 
                  ? `${getRandomAmount(sellAmountRange.min, sellAmountRange.max)}%`
                  : `${parseFloat(sellAmount)}%`;

                return processSellTransaction(wallet, sellPercentParam, index + 1, currentBatch.length)
                  .then(success => ({ wallet, success }));
              })
            );

            const batchFailedWallets = results.filter(r => !r.success).map(r => r.wallet);
            allFailedWallets = [...allFailedWallets, ...batchFailedWallets];
          }

          // 如果不是最后一批，等待指定时间后继续
          if (batchIndex < batches.length - 1) {
            await new Promise(resolve => setTimeout(resolve, BATCH_DELAY));
          }
        }

        return allFailedWallets;
      };

      // 首次执行
      failedWallets = await processBatch(selectedWalletObjects);

      // 如果有失败的交易，进行重试
      while (failedWallets.length > 0 && retryCount < MAX_RETRIES) {
        retryCount++;
        console.log(`第 ${retryCount} 次重试，失败钱包数: ${failedWallets.length}`);
        
        // 更新UI显示重试状态
        setError(`正在进行第 ${retryCount} 次重试，共 ${failedWallets.length} 个失败交易`);
        
        // 重新获取价格
        await fetchPriceAndLiquidityImmediate();
        
        // 等待5秒后重试
        await new Promise(resolve => setTimeout(resolve, 5000));
        
        // 执行重试
        failedWallets = await processBatch(failedWallets);
      }

      // 最终状态报告
      if (failedWallets.length > 0) {
        setError(`完成交易，但仍有 ${failedWallets.length} 个钱包交易失败`);
      } else {
        setError(null);
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setActiveTx(null);
    }
  };

  // ==================== 生命周期 ====================
  useEffect(() => {
    const initProvider = async () => {
      let lastError;
      
      for (const url of RPC_URLS) {
        try {
          const provider = new ethers.JsonRpcProvider(url);
          await provider.getBlockNumber();
          setCurrentRpcUrl(url);
          setProvider(provider);
          setError(null);
          return;
        } catch (err) {
          lastError = err;
          console.warn(`RPC ${url} 不可用，尝试下一个...`);
          continue;
        }
      }
      
      setError(`所有RPC节点均不可用: ${lastError?.message || '未知错误'}`);
    };
    
    initProvider();

    const handleAccountsChanged = (accounts) => {
      setConnectedAddress(accounts[0] || '');
      checkAdminStatus(accounts[0]);
    };

    window.ethereum?.on('accountsChanged', handleAccountsChanged);

    return () => {
      window.ethereum?.removeListener('accountsChanged', handleAccountsChanged);
    };
  }, []);

  useEffect(() => {
    if (provider && tokenAddress) {
      fetchTokenInfo();
      // 添加自动刷新价格的定时器
      const intervalId = setInterval(() => {
        fetchPriceAndLiquidityImmediate();
      }, 20000); // 每20秒更新一次价格
      
      return () => clearInterval(intervalId);
    }
  }, [provider, tokenAddress]);

  // ==================== 渲染部分 ====================
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          代币批量交易工具 {adminMode && <Chip label="管理员模式" color="primary" />}
        </Typography>

        {/* 价格信息显示 */}
        {tokenInfo.symbol && (
          <Paper sx={{ p: 2, mb: 3, border: '1px solid #e0f7fa', backgroundColor: '#e0f7fa' }}>
            <Typography variant="h6" gutterBottom color="primary">
              {tokenInfo.name} ({tokenInfo.symbol}) 价格信息
            </Typography>
            {priceInfo.price !== '0' ? (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                <Box>
                  <Typography variant="body2" color="text.secondary">当前价格</Typography>
                  <Typography variant="h6" color="primary" sx={{ fontFamily: 'monospace' }}>
                    {priceInfo.price} {priceInfo.pairToken}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">USDT价格</Typography>
                  <Typography variant="h6" color="primary" sx={{ fontFamily: 'monospace' }}>
                    ${priceInfo.usdtPrice}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">流动性</Typography>
                  <Typography variant="h6" sx={{ fontFamily: 'monospace' }}>
                    {priceInfo.liquidity} {priceInfo.pairToken}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2" color="text.secondary">最后更新</Typography>
                  <Typography variant="h6">
                    {new Date().toLocaleTimeString()}
                  </Typography>
                </Box>
                {priceInfo.source === 'PUMP' && (
                  <Box>
                    <Typography variant="body2" color="text.secondary">价格来源</Typography>
                    <Chip color="success" label="PUMP协议" size="small" />
                  </Box>
                )}
              </Box>
            ) : (
              <Box>
                <Alert severity="warning" sx={{ mb: 2 }}>
                  {priceInfo.status === 'No Liquidity' ? 
                    '该代币没有流动性池或尚未在交易所上市，无法获取价格信息' : 
                    '无法获取价格信息，请稍后再试'
                  }
                </Alert>
              </Box>
            )}
            
            {/* 添加PUMP协议详细信息显示 */}
            {priceInfo.source === 'PUMP' && priceInfo.offers && (
              <Box sx={{ mt: 2, p: 2, backgroundColor: '#e8f5e9', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom color="primary">
                  PUMP协议详细信息
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Offers数量</Typography>
                    <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>{priceInfo.offers}</Typography>
                  </Box>
                  {priceInfo.timestamp && (
                    <Box>
                      <Typography variant="body2" color="text.secondary">价格更新时间</Typography>
                      <Typography variant="body1">{priceInfo.timestamp}</Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
            
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
              <Button 
                variant="outlined" 
                color="success" 
                onClick={getPumpTokenPrice}
                size="small"
              >
                获取PUMP价格
              </Button>
            </Box>
          </Paper>
        )}

        {/* 管理员认证区域 */}
        {!adminMode && (
          <Paper sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6" gutterBottom>管理员认证</Typography>
            <Box sx={{ mb: 2 }}>
              <TextField
                label="连接的钱包地址"
                value={connectedAddress || '未连接'}
                fullWidth
                disabled
                sx={{ mb: 2 }}
              />
              {connectedAddress?.toLowerCase() !== ADMIN_CONFIG.adminAddress.toLowerCase() && (
                <>
                  <Button
                    variant="contained"
                    onClick={connectWallet}
                    sx={{ mb: 2 }}
                    fullWidth
                  >
                    连接钱包
                  </Button>
                  <TextField
                    label="管理员密码"
                    type="password"
                    value={adminPassword}
                    onChange={(e) => setAdminPassword(e.target.value)}
                    fullWidth
                  />
                </>
              )}
            </Box>
            <Button
              variant="contained"
              onClick={handleAdminLogin}
              disabled={!adminPassword && !connectedAddress}
              fullWidth
            >
              {connectedAddress?.toLowerCase() === ADMIN_CONFIG.adminAddress.toLowerCase() 
                ? '自动认证（管理员钱包）' 
                : '密码认证'}
            </Button>
          </Paper>
        )}

        {/* 安全警告对话框 */}
        <Dialog open={showSecurityWarning} onClose={() => setShowSecurityWarning(false)}>
          <DialogTitle>安全警告</DialogTitle>
          <DialogContent>
            <DialogContentText component="div">
              <strong>安全建议：</strong>
              <ul style={{ marginTop: '8px', paddingLeft: '24px' }}>
                <li>仅在安全环境下使用此工具</li>
                <li>使用后请及时清除浏览器历史记录</li>
                <li>刷新或关闭页面后私钥将自动清除</li>
                <li>建议使用专用钱包进行操作，不要导入主要资产钱包</li>
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowSecurityWarning(false)} color="primary">
              我已知晓
            </Button>
          </DialogActions>
        </Dialog>

        {/* 配置区域 */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>配置</Typography>
          
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <FormControl fullWidth sx={{ flex: 2 }}>
              <InputLabel>BSC节点RPC URL</InputLabel>
              <Select
                value={currentRpcUrl}
                onChange={(e) => setCurrentRpcUrl(e.target.value)}
                label="BSC节点RPC URL"
              >
                {RPC_URLS.map((url) => (
                  <MenuItem key={url} value={url}>
                    {url}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <TextField
              fullWidth
              label="代币合约地址"
              value={tokenAddress}
              onChange={(e) => {
                const newAddress = e.target.value.trim();
                setTokenAddress(newAddress);
                if (ethers.isAddress(newAddress) && provider) {
                  // 地址有效，立即获取信息
                  fetchTokenInfo();
                }
              }}
              sx={{ flex: 2 }}
            />
            
            {tokenInfo.name && (
              <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                <Chip 
                  label={`${tokenInfo.name} (${tokenInfo.symbol})`} 
                  color="primary" 
                  variant="outlined"
                />
              </Box>
            )}
          </Box>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              fullWidth
              label="批量导入私钥(每行一个)"
              value={privateKeys}
              onChange={(e) => setPrivateKeys(e.target.value)}
              multiline
              rows={4}
              placeholder="输入私钥，每行一个"
              sx={{ flex: 1 }}
            />
            
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Button
                variant="contained"
                onClick={importPrivateKeys}
                disabled={!privateKeys || !provider}
                size="large"
              >
                导入钱包
              </Button>
              
              {wallets.length > 0 && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                 
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        
        {/* 钱包列表 */}
        {wallets.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="h6">
                  钱包管理 (共 {wallets.length} 个, 已选 {selectedWallets.length} 个)
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => toggleSelectAll(true)}
                    disabled={wallets.length === 0 || selectedWallets.length === wallets.length}
                    color="primary"
                  >
                    全选
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => toggleSelectAll(false)}
                    disabled={wallets.length === 0 || selectedWallets.length === 0}
                    color="secondary"
                  >
                    取消全选
                  </Button>
                </Box>
              </Box>
              <Box>
                <Button 
                  variant="outlined" 
                  color="primary" 
                  onClick={() => fetchWalletsBalances(wallets)}
                  startIcon={<RefreshIcon />}
                  disabled={loading || wallets.length === 0}
                  size="small"
                  sx={{ mr: 1 }}
                >
                  刷新余额
                </Button>
                
                <Button 
                  variant="outlined" 
                  color="warning" 
                  onClick={checkAndRebalanceWallets}
                  disabled={loading || wallets.length < 2 || !adminMode}
                  size="small"
                >
                  余额补充
                </Button>
              </Box>
            </Box>
            
            {/* 添加总余额显示 */}
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <Paper sx={{ p: 2, flex: 1, bgcolor: 'background.default' }}>
                <Typography variant="subtitle2" color="text.secondary">总BNB余额</Typography>
                <Typography variant="h6">{totalBalances.bnb} BNB</Typography>
              </Paper>
              <Paper sx={{ p: 2, flex: 1, bgcolor: 'background.default' }}>
                <Typography variant="subtitle2" color="text.secondary">总代币余额</Typography>
                <Typography variant="h6">{totalBalances.token} {tokenInfo.symbol || 'TOKEN'}</Typography>
              </Paper>
              <Paper sx={{ p: 2, flex: 1, bgcolor: 'background.default' }}>
                <Typography variant="subtitle2" color="text.secondary">总持币价值(USDT)</Typography>
                <Typography variant="h6" color="primary">${totalTokenValue}</Typography>
              </Paper>
            </Box>
            
            <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>选择</TableCell>
                    <TableCell>地址</TableCell>
                    <TableCell align="right">BNB余额</TableCell>
                    <TableCell align="right">{tokenInfo.symbol || '代币'}余额</TableCell>
                    <TableCell align="right">持币价值(USDT)</TableCell>
                    <TableCell align="center">操作</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {wallets.map((wallet, index) => {
                    // 计算持币价值
                    const tokenValue = parseFloat(wallet.tokenBalance) * parseFloat(priceInfo.usdtPrice || 0);
                    const formattedValue = tokenValue.toFixed(2);
                    
                    return (
                      <TableRow key={wallet.address}>
                        <TableCell>
                          <Checkbox
                            checked={wallet.isSelected}
                            onChange={() => toggleWalletSelection(index)}
                          />
                        </TableCell>
                        <TableCell sx={{ fontFamily: 'monospace' }}>
                          {wallet.address}
                        </TableCell>
                        <TableCell align="right">{wallet.bnbBalance}</TableCell>
                        <TableCell align="right">{wallet.tokenBalance}</TableCell>
                        <TableCell align="right">
                          {priceInfo.usdtPrice ? (
                            <Typography 
                              color={tokenValue > 0 ? "primary" : "text.secondary"}
                              sx={{ fontFamily: 'monospace' }}
                            >
                              ${formattedValue}
                            </Typography>
                          ) : (
                            <Typography color="text.secondary">-</Typography>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => deleteWallet(wallet.address)}
                            sx={{ minWidth: '80px' }}
                          >
                            删除
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        
        {/* 交易设置区域 */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">交易设置</Typography>
            <Button 
              variant="outlined" 
              onClick={() => setShowVolumeSettings(!showVolumeSettings)}
            >
              {showVolumeSettings ? '隐藏刷量设置' : '显示刷量设置'}
            </Button>
          </Box>
          
          {/* 常规交易设置 */}
          <Paper sx={{ p: 2, mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom>交易设置</Typography>
            
            {/* GAS费用设置 */}
            <Typography variant="subtitle2" gutterBottom>GAS费用设置</Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={3}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={customGasEnabled}
                      onChange={(e) => setCustomGasEnabled(e.target.checked)}
                      disabled={loading}
                    />
                  }
                  label="自定义GAS"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="GAS价格(Gwei)"
                  type="number"
                  value={customGasPrice}
                  onChange={(e) => setCustomGasPrice(e.target.value)}
                  disabled={!customGasEnabled || loading}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="GAS限制"
                  type="number"
                  value={customGasLimit}
                  onChange={(e) => setCustomGasLimit(e.target.value)}
                  disabled={!customGasEnabled || loading}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                {customGasEnabled && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    估计GAS费: {(parseFloat(customGasPrice) * 0.000000001 * parseInt(customGasLimit)).toFixed(8)} BNB
                  </Typography>
                )}
              </Grid>
            </Grid>
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={batchBuyTokens}
                disabled={loading || selectedWallets.length === 0 || !tokenAddress}
                sx={{ flex: 1 }}
              >
                批量买入
              </Button>
              
              <Button
                variant="contained"
                color="secondary"
                onClick={batchSellTokens}
                disabled={loading || selectedWallets.length === 0 || !tokenAddress}
                sx={{ flex: 1 }}
              >
                批量卖出
              </Button>
            </Box>
          </Paper>
          
          {/* 刷交易量设置 - 折叠面板 */}
          <Collapse in={showVolumeSettings}>
            <Paper sx={{ p: 2, mb: 3, backgroundColor: '#f5f5f5' }}>
              <Typography variant="subtitle1" gutterBottom>刷交易量设置</Typography>
              
              <Box sx={{ display: 'flex', gap: 3, mb: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography gutterBottom>买入比例: {buyPercentage}%</Typography>
                  <Slider
                    value={buyPercentage}
                    onChange={(e, newValue) => {
                      setBuyPercentage(newValue);
                      setSellPercentage(100 - newValue);
                    }}
                    min={0}
                    max={100}
                    step={5}
                    valueLabelDisplay="auto"
                    disabled={isVolumeTrading}
                  />
                </Box>
                
                <Box sx={{ flex: 1 }}>
                  <Typography gutterBottom>卖出比例: {sellPercentage}%</Typography>
                  <Slider
                    value={sellPercentage}
                    onChange={(e, newValue) => {
                      setSellPercentage(newValue);
                      setBuyPercentage(100 - newValue);
                    }}
                    min={0}
                    max={100}
                    step={5}
                    valueLabelDisplay="auto"
                    disabled={isVolumeTrading}
                  />
                </Box>
              </Box>

              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <TextField
                  fullWidth
                  label="买入BNB数量"
                  type="number"
                  value={volumeBuyAmount}
                  onChange={(e) => setVolumeBuyAmount(e.target.value)}
                  inputProps={{ min: "0.000001", step: "0.000001" }}
                  disabled={isVolumeTrading}
                />
                <TextField
                  fullWidth
                  label="卖出代币数量"
                  type="number"
                  value={volumeSellAmount}
                  onChange={(e) => setVolumeSellAmount(e.target.value)}
                  inputProps={{ min: "0.000001", step: "0.000001" }}
                  disabled={isVolumeTrading}
                />
              </Box>

              {/* 刷量交易GAS设置 */}
              <Typography variant="subtitle2" gutterBottom>GAS费用设置</Typography>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={customGasEnabled}
                        onChange={(e) => setCustomGasEnabled(e.target.checked)}
                        disabled={isVolumeTrading}
                      />
                    }
                    label="自定义GAS"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label="GAS价格(Gwei)"
                    type="number"
                    value={customGasPrice}
                    onChange={(e) => setCustomGasPrice(e.target.value)}
                    disabled={!customGasEnabled || isVolumeTrading}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label="GAS限制"
                    type="number"
                    value={customGasLimit}
                    onChange={(e) => setCustomGasLimit(e.target.value)}
                    disabled={!customGasEnabled || isVolumeTrading}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  {customGasEnabled && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      估计GAS费: {(parseFloat(customGasPrice) * 0.000000001 * parseInt(customGasLimit)).toFixed(8)} BNB
                    </Typography>
                  )}
                </Grid>
              </Grid>

              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={useVolumeRandomBuyAmount}
                      onChange={(e) => setUseVolumeRandomBuyAmount(e.target.checked)}
                      disabled={isVolumeTrading}
                    />
                  }
                  label="买入随机金额"
                />
                {useVolumeRandomBuyAmount && (
                  <Box sx={{ display: 'flex', gap: 2, flex: 1 }}>
                    <TextField
                      label="最小买入金额"
                      type="number"
                      value={volumeBuyAmountRange.min}
                      onChange={(e) => setVolumeBuyAmountRange({...volumeBuyAmountRange, min: e.target.value})}
                      inputProps={{ min: "0.000001", step: "0.000001" }}
                      disabled={isVolumeTrading}
                    />
                    <TextField
                      label="最大买入金额"
                      type="number"
                      value={volumeBuyAmountRange.max}
                      onChange={(e) => setVolumeBuyAmountRange({...volumeBuyAmountRange, max: e.target.value})}
                      inputProps={{ min: "0.000001", step: "0.000001" }}
                      disabled={isVolumeTrading}
                    />
                  </Box>
                )}
              </Box>

              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={useVolumeRandomSellAmount}
                      onChange={(e) => setUseVolumeRandomSellAmount(e.target.checked)}
                      disabled={isVolumeTrading}
                    />
                  }
                  label="卖出随机金额"
                />
                {useVolumeRandomSellAmount && (
                  <Box sx={{ display: 'flex', gap: 2, flex: 1 }}>
                    <TextField
                      label="最小卖出金额"
                      type="number"
                      value={volumeSellAmountRange.min}
                      onChange={(e) => setVolumeSellAmountRange({...volumeSellAmountRange, min: e.target.value})}
                      inputProps={{ min: "0.000001", step: "0.000001" }}
                      disabled={isVolumeTrading}
                    />
                    <TextField
                      label="最大卖出金额"
                      type="number"
                      value={volumeSellAmountRange.max}
                      onChange={(e) => setVolumeSellAmountRange({...volumeSellAmountRange, max: e.target.value})}
                      inputProps={{ min: "0.000001", step: "0.000001" }}
                      disabled={isVolumeTrading}
                    />
                  </Box>
                )}
              </Box>

              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <TextField
                  label="循环次数"
                  type="number"
                  value={volumeRounds}
                  onChange={(e) => setVolumeRounds(Math.max(1, parseInt(e.target.value) || 1))}
                  sx={{ width: 120 }}
                  disabled={isVolumeTrading}
                />
                {isVolumeTrading ? (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      setIsVolumeTrading(false);
                      setVolumeTradeStatus(prev => ({
                        ...prev,
                        isRunning: false,
                        currentAction: '已停止'
                      }));
                    }}
                    startIcon={<CircularProgress size={20} />}
                    fullWidth
                  >
                    停止刷量
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      console.log("开始执行刷量交易");
                      runVolumeTrade().catch(err => {
                        console.error("刷量交易执行失败:", err);
                        setError(err.message);
                      });
                    }}
                    disabled={loading || selectedWallets.length === 0 || !adminMode}
                    fullWidth
                  >
                    {loading && activeTx ? (
                      <CircularProgress size={24} sx={{ mr: 1 }} />
                    ) : null}
                    执行刷量交易 ({selectedWallets.length}个钱包)
                  </Button>
                )}
              </Box>

              {isVolumeTrading && (
                <Box sx={{ mt: 2, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
                  <Typography variant="subtitle2" gutterBottom>刷量交易状态</Typography>
                  <Typography>当前轮次: {volumeTradeStatus.currentRound}/{volumeTradeStatus.totalRounds}</Typography>
                  <Typography>当前操作: {volumeTradeStatus.currentAction}</Typography>
                  <Typography>处理进度: {volumeTradeStatus.processedCount}/{volumeTradeStatus.totalCount}</Typography>
                </Box>
              )}

              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={volumeBuySequentialMode}
                      onChange={(e) => setVolumeBuySequentialMode(e.target.checked)}
                      disabled={isVolumeTrading}
                    />
                  }
                  label="买入顺序执行"
                />
                {volumeBuySequentialMode && (
                  <TextField
                    label="买入间隔(秒)"
                    type="number"
                    value={volumeBuyDelayBetweenTx}
                    onChange={(e) => setVolumeBuyDelayBetweenTx(Math.max(0, parseInt(e.target.value) || 0))}
                    sx={{ width: 120 }}
                    disabled={isVolumeTrading}
                  />
                )}
                <FormControlLabel
                  control={
                    <Switch
                      checked={volumeSellSequentialMode}
                      onChange={(e) => setVolumeSellSequentialMode(e.target.checked)}
                      disabled={isVolumeTrading}
                    />
                  }
                  label="卖出顺序执行"
                />
                {volumeSellSequentialMode && (
                  <TextField
                    label="卖出间隔(秒)"
                    type="number"
                    value={volumeSellDelayBetweenTx}
                    onChange={(e) => setVolumeSellDelayBetweenTx(Math.max(0, parseInt(e.target.value) || 0))}
                    sx={{ width: 120 }}
                    disabled={isVolumeTrading}
                  />
                )}
              </Box>
            </Paper>
          </Collapse>
          
          <Box sx={{ mb: 2 }}>
            <Alert severity="info">
              当前滑点设置: 买入 {buySlippage}% / 卖出 {sellSlippage}%
              {parseFloat(buySlippage) > 5 || parseFloat(sellSlippage) > 5 ? (
                <strong> - 滑点过高可能导致交易失败!</strong>
              ) : null}
            </Alert>
          </Box>
          
          <Box sx={{ display: 'flex', gap: 3 }}>
            {/* 买入设置 */}
            <Paper sx={{ p: 2, flex: 1 }}>
              <Typography variant="subtitle1" gutterBottom>买入设置</Typography>
              
              <FormControlLabel
                control={
                  <Switch
                    checked={useRandomBuyAmount}
                    onChange={(e) => setUseRandomBuyAmount(e.target.checked)}
                  />
                }
                label="使用随机金额"
                sx={{ mb: 2 }}
              />
              
              {useRandomBuyAmount ? (
                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                  <TextField
                    fullWidth
                    label="最小买入金额"
                    value={buyAmountRange.min}
                    onChange={(e) => setBuyAmountRange({...buyAmountRange, min: e.target.value})}
                    type="number"
                    inputProps={{ min: "0.000001", step: "0.000001" }}
                  />
                  <TextField
                    fullWidth
                    label="最大买入金额"
                    value={buyAmountRange.max}
                    onChange={(e) => setBuyAmountRange({...buyAmountRange, max: e.target.value})}
                    type="number"
                    inputProps={{ min: "0.000001", step: "0.000001" }}
                  />
                </Box>
              ) : (
                <TextField
                  fullWidth
                  label="买入金额(BNB)"
                  value={buyAmount}
                  onChange={(e) => setBuyAmount(e.target.value)}
                  type="number"
                  sx={{ mb: 2 }}
                  inputProps={{ min: "0.000001", step: "0.000001" }}
                />
              )}
              
              <TextField
                fullWidth
                label="滑点(%)"
                value={buySlippage}
                onChange={(e) => setBuySlippage(e.target.value)}
                type="number"
                sx={{ mb: 2 }}
                inputProps={{ min: "0.1", step: "0.1" }}
              />
              
              <FormControlLabel
                control={
                  <Switch
                    checked={buySequentialMode}
                    onChange={(e) => setBuySequentialMode(e.target.checked)}
                  />
                }
                label="顺序执行"
                sx={{ mb: 2 }}
              />
              
              {buySequentialMode && (
                <TextField
                  fullWidth
                  label="交易间隔(秒)"
                  value={buyDelayBetweenTx}
                  onChange={(e) => setBuyDelayBetweenTx(e.target.value)}
                  type="number"
                  sx={{ mb: 2 }}
                  inputProps={{ min: "0", step: "1" }}
                />
              )}
              
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={batchBuyTokens}
                disabled={loading || selectedWallets.length === 0 || !adminMode}
                size="large"
              >
                {loading && activeTx?.type === '买入' ? (
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                ) : null}
                批量买入 ({selectedWallets.length}个钱包)
              </Button>
            </Paper>
            
            {/* 卖出设置 */}
            <Paper sx={{ p: 2, flex: 1 }}>
              <Typography variant="subtitle1" gutterBottom>卖出设置</Typography>
              
              <FormControlLabel
                control={
                  <Switch
                    checked={useRandomSellAmount}
                    onChange={(e) => setUseRandomSellAmount(e.target.checked)}
                  />
                }
                label="使用随机百分比"
                sx={{ mb: 2 }}
              />
              
              {useRandomSellAmount ? (
                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                  <TextField
                    fullWidth
                    label="最小卖出百分比"
                    value={sellAmountRange.min}
                    onChange={(e) => setSellAmountRange({...sellAmountRange, min: e.target.value})}
                    type="number"
                    inputProps={{ min: "1", max: "100", step: "1" }}
                    InputProps={{
                      endAdornment: <Typography>%</Typography>
                    }}
                  />
                  <TextField
                    fullWidth
                    label="最大卖出百分比"
                    value={sellAmountRange.max}
                    onChange={(e) => setSellAmountRange({...sellAmountRange, max: e.target.value})}
                    type="number"
                    inputProps={{ min: "1", max: "100", step: "1" }}
                    InputProps={{
                      endAdornment: <Typography>%</Typography>
                    }}
                  />
                </Box>
              ) : (
                <TextField
                  fullWidth
                  label="卖出百分比"
                  value={sellAmount}
                  onChange={(e) => setSellAmount(e.target.value)}
                  type="number"
                  sx={{ mb: 2 }}
                  inputProps={{ min: "1", max: "100", step: "1" }}
                  InputProps={{
                    endAdornment: <Typography>%</Typography>
                  }}
                />
              )}
              
              <TextField
                fullWidth
                label="滑点(%)"
                value={sellSlippage}
                onChange={(e) => setSellSlippage(e.target.value)}
                type="number"
                sx={{ mb: 2 }}
                inputProps={{ min: "0.1", step: "0.1" }}
              />
              
              <FormControlLabel
                control={
                  <Switch
                    checked={sellSequentialMode}
                    onChange={(e) => setSellSequentialMode(e.target.checked)}
                  />
                }
                label="顺序执行"
                sx={{ mb: 2 }}
              />
              
              {sellSequentialMode && (
                <TextField
                  fullWidth
                  label="交易间隔(秒)"
                  value={sellDelayBetweenTx}
                  onChange={(e) => setSellDelayBetweenTx(e.target.value)}
                  type="number"
                  sx={{ mb: 2 }}
                  inputProps={{ min: "0", step: "1" }}
                />
              )}
              
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                onClick={batchSellTokens}
                disabled={loading || selectedWallets.length === 0 || !adminMode}
                size="large"
              >
                {loading && activeTx?.type === '卖出' ? (
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                ) : null}
                批量卖出 ({selectedWallets.length}个钱包)
              </Button>
            </Paper>
          </Box>
        </Box>
        
        {/* 当前交易状态 */}
        {activeTx && (
          <Box sx={{ mb: 3, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1 }}>
            <Typography variant="subtitle1" gutterBottom>
              正在{activeTx.type}交易 ({activeTx.index}/{activeTx.total})
            </Typography>
            <Typography>钱包: {activeTx.wallet}</Typography>
            <Typography>数量: {activeTx.amount} {activeTx.type === '买入' ? 'BNB' : tokenInfo.symbol}</Typography>
            <Typography>状态: {activeTx.status}</Typography>
          </Box>
        )}
        
        {/* 错误提示 */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}
        
        {/* 交易历史 */}
        {txHistory.length > 0 && (
          <Box>
            <Typography variant="h6" gutterBottom>交易历史</Typography>
            
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>时间</TableCell>
                    <TableCell>类型</TableCell>
                    <TableCell>钱包</TableCell>
                    <TableCell align="right">花费</TableCell>
                    <TableCell align="right">获得</TableCell>
                    <TableCell>状态</TableCell>
                    <TableCell>备注</TableCell>
                    <TableCell>操作</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {txHistory.map((tx, index) => (
                    <TableRow key={index}>
                      <TableCell>{tx.timestamp}</TableCell>
                      <TableCell>{tx.type}</TableCell>
                      <TableCell sx={{ fontFamily: 'monospace' }}>
                        {tx.wallet.slice(0, 6)}...{tx.wallet.slice(-4)}
                      </TableCell>
                      <TableCell align="right">
                        {tx.spentAmount} {tx.spentSymbol}
                      </TableCell>
                      <TableCell align="right">
                        {tx.receivedAmount ? (
                          <>
                            {tx.receivedAmount} {tx.receivedSymbol}
                          </>
                        ) : '-'}
                      </TableCell>
                      <TableCell>
                        {tx.status === '已完成' ? (
                          <Chip label="成功" color="success" size="small" />
                        ) : tx.status === '失败' ? (
                          <Chip label="失败" color="error" size="small" />
                        ) : (
                          <Chip label="处理中" color="warning" size="small" />
                        )}
                      </TableCell>
                      <TableCell>
                        {tx.note || (tx.error ? <Chip label="错误" color="error" size="small" title={tx.error} /> : '')}
                      </TableCell>
                      <TableCell>
                        {tx.explorerUrl && (
                          <Button 
                            size="small" 
                            href={tx.explorerUrl} 
                            target="_blank"
                          >
                            查看
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {/* 确认对话框 */}
        <Dialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
        >
          <DialogTitle>确认操作</DialogTitle>
          <DialogContent>
            {pendingAction?.type === 'rebalance' && (
              <DialogContentText>
                发现{pendingAction.insufficientWallets.length}个钱包余额不足，
                是否从余额充足的钱包中自动转入BNB？
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowConfirmDialog(false)} color="primary">
              取消
            </Button>
            <Button 
              onClick={() => {
                setShowConfirmDialog(false);
                if (pendingAction?.type === 'rebalance') {
                  executeRebalance(pendingAction);
                }
              }} 
              color="primary"
              autoFocus
            >
              确认
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Container>
  );
}

export default AdminBatchTokenSwap;